// import React, {
//   useState,
//   useEffect,
//   useRef,
//   useLayoutEffect,
//   useMemo,
// } from "react";
// import { createPortal } from "react-dom";
// import Button from "../../Buttons/Button";
// import FormFieldSet from "../FormFieldSet";
// import {
//   datePickerOptions,
//   predefinedDatePickerOptions,
//   singleDatePickerOptions,
// } from "../../../assets/data/enumData";
// import { getDateByOption } from "../../../utils/getDateByOption";
// const sizeClasses = {
//   sm: "px-3 py-1.5",
//   md: "px-3 py-2",
//   lg: "px-4 py-2.5",
//   xl: "px-5 py-3",
// };

// const fontSizeClasses = {
//   sm: "text-[12px]",
//   md: "text-[14px]",
//   lg: "text-[16px]",
//   xl: "text-[18px]",
// };

// const iconSizeClasses = {
//   sm: "!text-[14px]",
//   md: "!text-[14px]",
//   lg: "!text-[15px]",
//   xl: "!text-[15px]",
// };

// const fontSizeDatesClasses = {
//   sm: "text-[10px]",
//   md: "text-[12px]",
//   lg: "text-[14px]",
//   xl: "text-[16px]",
// };

// // Button component mock for demo

// const formatDateToLocalISO = (date) => {
//   if (!date || !(date instanceof Date) || isNaN(date)) return null;

//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   const hours = String(date.getHours()).padStart(2, "0");
//   const minutes = String(date.getMinutes()).padStart(2, "0");
//   const seconds = String(date.getSeconds()).padStart(2, "0");

//   return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
// };

// const CustomDatePicker = ({
//   selected,
//   onChange = () => {},
//   placeholder = "Select a date",
//   size = "md",
//   rounded = "rounded",
//   maxDate,
//   minDate,
//   range = false,
//   disabled = false,
//   blockDates = [],
//   shadow = false,
//   showTime = false,
//   showDropdown = true, //prop to control dropdown visibility
//   dropdownOptions = "predefined", //predefined , all
//   defaultOption,
// }) => {
//   const optionsToShow = range
//     ? dropdownOptions === "predefined"
//       ? predefinedDatePickerOptions
//       : datePickerOptions
//     : singleDatePickerOptions;

//   // Normalize blocked dates to comparable strings
//   const normalizedBlockedDates = useMemo(() => {
//     const blockedSet = new Set();

//     blockDates.forEach((entry) => {
//       // Case 1: single date (string or Date)
//       if (entry instanceof Date || typeof entry === "string") {
//         blockedSet.add(new Date(entry).toDateString());
//       }
//       // Case 2: range object { from, to }
//       else if (entry && entry.from && entry.to) {
//         const from = new Date(entry.from);
//         const to = new Date(entry.to);

//         let current = new Date(from);
//         while (current <= to) {
//           blockedSet.add(new Date(current).toDateString());
//           current.setDate(current.getDate() + 1);
//         }
//       }
//     });

//     return Array.from(blockedSet);
//   }, [blockDates]);

//   const parseDate = (dateInput, preserveTime = false) => {
//     if (!dateInput) return null;

//     if (typeof dateInput === "string") {
//       if (dateInput.includes("T")) {
//         const datePart = dateInput.split("T")[0];
//         const [year, month, day] = datePart.split("-").map(Number);
//         return new Date(year, month - 1, day);
//       }

//       if (dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
//         const [year, month, day] = dateInput.split("-").map(Number);
//         return new Date(year, month - 1, day);
//       }
//     }

//     if (dateInput instanceof Date && !isNaN(dateInput)) {
//       if (preserveTime || showTime) {
//         return new Date(dateInput.getTime());
//       }
//       return new Date(
//         dateInput.getFullYear(),
//         dateInput.getMonth(),
//         dateInput.getDate(),
//       );
//     }

//     const date = new Date(dateInput);
//     return isNaN(date.getTime()) ? null : date;
//   };

//   const getOptionByLabel = (label, options) => {
//     if (!label) return null;
//     return options.find(
//       (opt) => opt.label.toLowerCase() === label.toLowerCase(),
//     );
//   };

//   const [isOpen, setIsOpen] = useState(false);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [selectedPreset, setSelectedPreset] = useState(null);
//   const [currentDate, setCurrentDate] = useState(
//     parseDate(range ? selected?.from || selected?.start : selected) ||
//       new Date(),
//   );
//   const [selectedDate, setSelectedDate] = useState(parseDate(selected));
//   const dropdownRef = useRef(null);
//   const inputRef = useRef(null);
//   const buttonRef = useRef(null);
//   const dropdownContainerRef = useRef(null);

//   // Range mode states
//   const [fromDate, setFromDate] = useState(
//     parseDate(range ? selected?.from || selected?.start : null),
//   );
//   const [toDate, setToDate] = useState(
//     parseDate(range ? selected?.to || selected?.end : null),
//   );
//   const [selectionMode, setSelectionMode] = useState(fromDate ? "to" : "from");

//   const [showMonthsList, setShowMonthsList] = useState(false);
//   const [showYearsList, setShowYearsList] = useState(false);
//   const [tempSelectedDate, setTempSelectedDate] = useState(null);

//   // New states for typing functionality
//   const [inputValue, setInputValue] = useState("");
//   const [isTyping, setIsTyping] = useState(false);
//   // New states for Time
//   const [hours, setHours] = useState("12");
//   const [minutes, setMinutes] = useState("00");
//   const [period, setPeriod] = useState("AM");

//   useEffect(() => {
//     setSelectedDate(parseDate(selected));
//   }, [selected]);

//   useEffect(() => {
//     if (!selected) return;

//     const date = new Date(selected);
//     if (isNaN(date.getTime())) return;

//     let hrs = date.getHours();
//     let mins = date.getMinutes();
//     let periodValue = hrs >= 12 ? "PM" : "AM";

//     // Convert to 12-hour format
//     hrs = hrs % 12;
//     hrs = hrs === 0 ? 12 : hrs;

//     setHours(String(hrs).padStart(2, "0"));
//     setMinutes(String(mins).padStart(2, "0"));
//     setPeriod(periodValue);
//   }, [selected, showTime]);

//   useEffect(() => {
//     if (
//       defaultOption &&
//       (!selected || (selected?.from === null && selected?.to === null))
//     ) {
//       let option = null;

//       if (!isNaN(defaultOption)) {
//         const optionValue = parseInt(defaultOption);
//         option = optionsToShow.find((opt) => opt.value === optionValue);
//       } else {
//         option = getOptionByLabel(defaultOption, optionsToShow);
//       }

//       if (option && option.value !== 12) {
//         const result = getDateByOption(option.value);

//         // SINGLE DATE MODE
//         if (!range && result instanceof Date) {
//           setSelectedDate(result);
//           setCurrentDate(result);
//           setSelectedPreset(option);
//           onChange(formatDateToLocalISO(result));
//           return;
//         }

//         // RANGE MODE
//         if (range && result?.startDate) {
//           setFromDate(result.startDate);
//           setToDate(result.endDate);
//           setSelectionMode("from");
//           setSelectedPreset(option);

//           onChange({
//             from: formatDateToLocalISO(result.startDate),
//             to: formatDateToLocalISO(result.endDate),
//           });
//         }
//       }
//     }
//   }, [[defaultOption, selected, range]]);

//   const months = [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ];

//   const fullMonths = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   // Generate hours array (01-12)
//   const hoursArray = Array.from({ length: 12 }, (_, i) => ({
//     label: String(i + 1).padStart(2, "0"),
//     value: String(i + 1).padStart(2, "0"),
//   }));

//   // Generate minutes array (00-59)
//   const minutesArray = Array.from({ length: 60 }, (_, i) => ({
//     label: String(i).padStart(2, "0"),
//     value: String(i).padStart(2, "0"),
//   }));

//   const periodArray = [
//     { label: "AM", value: "AM" },
//     { label: "PM", value: "PM" },
//   ];

//   // Get dynamic year limits based on minDate and maxDate
//   const getYearLimits = () => {
//     const currentYear = new Date().getFullYear();
//     const defaultMinYear = 1900;
//     const defaultMaxYear = currentYear + 100; // Allow 100 years into the future by default

//     const minYear = minDate ? parseDate(minDate).getFullYear() : defaultMinYear;
//     const maxYear = maxDate ? parseDate(maxDate).getFullYear() : defaultMaxYear;

//     return { minYear, maxYear };
//   };
//   const isSameDay = (d1, d2) => {
//     if (!d1 || !d2) return false;
//     return (
//       d1.getFullYear() === d2.getFullYear() &&
//       d1.getMonth() === d2.getMonth() &&
//       d1.getDate() === d2.getDate()
//     );
//   };

//   const isToday = (date) => {
//     if (!date) return false;

//     const today = new Date();
//     return (
//       date.getDate() === today.getDate() &&
//       date.getMonth() === today.getMonth() &&
//       date.getFullYear() === today.getFullYear()
//     );
//   };

//   // Format date for display in readable format (Feb 11, 2025)

//   const formatDateReadable = (date) => {
//     if (!date || !(date instanceof Date) || isNaN(date)) return "";

//     if (isToday(date)) return "Today";

//     try {
//       const month = months[date.getMonth()];
//       const day = date.getDate();
//       const year = date.getFullYear();
//       return `${month} ${day}, ${year}`;
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return "";
//     }
//   };

//   const formatDateWithTime = (date, hrs, mins, per) => {
//     if (!date) return "";
//     const dateStr = formatDateReadable(date);
//     return `${dateStr} ${hrs}:${mins} ${per}`;
//   };

//   // Format date for input (MM/DD/YYYY)
//   const formatDate = (date) => {
//     if (!date || !(date instanceof Date) || isNaN(date)) return "";
//     try {
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const day = String(date.getDate()).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${month}/${day}/${year}`;
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return "";
//     }
//   };

//   const formatDateRange = () => {
//     if (fromDate && toDate) {
//       return `${formatDateReadable(fromDate)} - ${formatDateReadable(toDate)}`;
//     } else if (fromDate) {
//       return `${formatDateReadable(fromDate)} - Select end date`;
//     } else {
//       return ""; // Use the provided placeholder instead of hardcoded text
//     }
//   };

//   // Parse MM/DD/YYYY input
//   const parseInputDate = (input) => {
//     const cleaned = input.replace(/\D/g, ""); // Remove non-digits

//     if (cleaned.length < 8) return null; // Need at least MMDDYYYY

//     const month = parseInt(cleaned.substring(0, 2), 10);
//     const day = parseInt(cleaned.substring(2, 4), 10);
//     const year = parseInt(cleaned.substring(4, 8), 10);

//     const { minYear, maxYear } = getYearLimits();

//     if (
//       month < 1 ||
//       month > 12 ||
//       day < 1 ||
//       day > 31 ||
//       year < minYear ||
//       year > maxYear
//     ) {
//       return null;
//     }

//     const date = new Date(year, month - 1, day);
//     if (date.getMonth() !== month - 1) return null; // Invalid date like Feb 30

//     return date;
//   };

//   // Auto-format input as user types
//   const formatInput = (value) => {
//     const cleaned = value.replace(/\D/g, "");
//     let formatted = "";

//     if (cleaned.length >= 1) {
//       formatted = cleaned.substring(0, 2);
//     }
//     if (cleaned.length >= 3) {
//       formatted += "/" + cleaned.substring(2, 4);
//     }
//     if (cleaned.length >= 5) {
//       formatted += "/" + cleaned.substring(4, 8);
//     }

//     return formatted;
//   };

//   // Auto-correct invalid dates with dynamic year limits
//   const autoCorrectDate = (
//     input,
//     preserveTime = false,
//     existingDate = null,
//   ) => {
//     const cleaned = input.replace(/\D/g, "");
//     if (cleaned.length < 8) return null;

//     let month = parseInt(cleaned.substring(0, 2), 10);
//     let day = parseInt(cleaned.substring(2, 4), 10);
//     let year = parseInt(cleaned.substring(4, 8), 10);

//     const { minYear, maxYear } = getYearLimits();

//     // Auto-correct month
//     if (month > 12) month = 12;
//     if (month < 1) month = 1;

//     // Auto-correct year based on minDate and maxDate
//     if (year < minYear) year = minYear;
//     if (year > maxYear) year = maxYear;

//     // Auto-correct day based on month and year
//     const daysInMonth = new Date(year, month, 0).getDate();
//     if (day > daysInMonth) day = daysInMonth;
//     if (day < 1) day = 1;

//     let correctedDate;

//     if (preserveTime && existingDate) {
//       // Preserve time from existing date
//       correctedDate = new Date(
//         year,
//         month - 1,
//         day,
//         existingDate.getHours(),
//         existingDate.getMinutes(),
//         existingDate.getSeconds(),
//         existingDate.getMilliseconds(),
//       );
//     } else if (showTime) {
//       // Use current time picker values
//       let hrs = parseInt(hours, 10);
//       if (period === "PM" && hrs !== 12) hrs += 12;
//       if (period === "AM" && hrs === 12) hrs = 0;

//       correctedDate = new Date(
//         year,
//         month - 1,
//         day,
//         hrs,
//         parseInt(minutes, 10),
//       );
//     } else {
//       correctedDate = new Date(year, month - 1, day);
//     }

//     // Validate against min/max dates
//     if (minDate && correctedDate < minDate) {
//       return minDate;
//     }
//     if (maxDate && correctedDate > maxDate) {
//       return maxDate;
//     }

//     return correctedDate;
//   };

//   // Handle input change
//   const handleInputChange = (e) => {
//     const value = e.target.value;

//     // If the input is being cleared, handle it properly
//     if (value === "") {
//       setInputValue("");
//       setIsTyping(true);
//       return;
//     }

//     setIsTyping(true);

//     // Handle paste or direct input of invalid dates
//     if (value.length >= 8 && value !== inputValue) {
//       const correctedDate = autoCorrectDate(value);
//       if (correctedDate) {
//         const formattedDate = formatDate(correctedDate);
//         setInputValue(formattedDate);

//         if (!range) {
//           setSelectedDate(correctedDate);
//           onChange(correctedDate);
//           setIsTyping(false);
//         } else {
//           if (selectionMode === "from") {
//             setFromDate(correctedDate);
//             setSelectionMode("to");
//             onChange({ from: correctedDate, to: toDate });
//           } else {
//             setToDate(correctedDate);
//             setSelectionMode("from");
//             onChange({ from: fromDate, to: correctedDate });
//             setIsTyping(false);
//           }
//         }
//         return;
//       }
//     }

//     // Format the input normally
//     const formatted = formatInput(value);
//     setInputValue(formatted);

//     // Try to parse complete date
//     const parsedDate = parseInputDate(formatted);
//     if (parsedDate && formatted.length === 10) {
//       if (!range) {
//         setSelectedDate(parsedDate);
//         onChange(parsedDate);
//         setIsTyping(false);
//       } else {
//         if (selectionMode === "from") {
//           setFromDate(parsedDate);
//           setSelectionMode("to");
//           onChange({ from: parsedDate, to: toDate });
//         } else {
//           setToDate(parsedDate);
//           setSelectionMode("from");
//           onChange({ from: fromDate, to: parsedDate });
//           setIsTyping(false);
//         }
//       }
//     }
//   };

//   // Handle backspace logic
//   const handleKeyDown = (e) => {
//     const input = e.target;
//     const isTextSelected = input.selectionStart !== input.selectionEnd;
//     const displayValue = getDisplayValue();

//     if (e.key === "Backspace") {
//       e.preventDefault();

//       // If there's any selected date or if text is selected, clear everything
//       if (
//         isTextSelected ||
//         (!range && selectedDate) ||
//         (range && (fromDate || toDate))
//       ) {
//         // Clear the input
//         setInputValue("");
//         setIsTyping(true);

//         // Clear dates based on range mode
//         if (range) {
//           if (toDate) {
//             // Remove end date first
//             setToDate(null);
//             setSelectionMode("to");
//             onChange({ from: fromDate, to: null });
//           } else if (fromDate) {
//             // Remove start date
//             setFromDate(null);
//             setSelectionMode("from");
//             onChange({ from: null, to: null });
//           }
//         } else {
//           // Single date mode - remove the date
//           setSelectedDate(null);
//           onChange(null);
//         }
//       } else if (isTyping && inputValue) {
//         // If user is typing, allow normal backspace behavior for the input
//         const newValue = inputValue.slice(0, -1);
//         setInputValue(newValue);
//       }
//     } else if (e.key === "Delete") {
//       // Handle Delete key same as Backspace for selected text or complete dates
//       if (
//         isTextSelected ||
//         (!range && selectedDate) ||
//         (range && (fromDate || toDate))
//       ) {
//         e.preventDefault();
//         setInputValue("");
//         setIsTyping(true);

//         if (range) {
//           if (toDate) {
//             setToDate(null);
//             setSelectionMode("to");
//             onChange({ from: fromDate, to: null });
//           } else if (fromDate) {
//             setFromDate(null);
//             setSelectionMode("from");
//             onChange({ from: null, to: null });
//           }
//         } else {
//           setSelectedDate(null);
//           onChange(null);
//         }
//       }
//     } else if (e.key === "Enter") {
//       // Try to parse and set the date on Enter
//       let parsedDate = parseInputDate(inputValue);

//       // If invalid, try auto-correction
//       if (!parsedDate && inputValue) {
//         parsedDate = autoCorrectDate(inputValue);
//         if (parsedDate) {
//           const correctedFormat = formatDate(parsedDate);
//           setInputValue(correctedFormat);
//         }
//       }

//       if (parsedDate) {
//         if (!range) {
//           setSelectedDate(parsedDate);
//           onChange(parsedDate);
//         } else {
//           if (selectionMode === "from") {
//             setFromDate(parsedDate);
//             setSelectionMode("to");
//             onChange({ from: parsedDate, to: toDate });
//           } else {
//             setToDate(parsedDate);
//             setSelectionMode("from");
//             onChange({ from: fromDate, to: parsedDate });
//           }
//         }
//         setIsTyping(false);
//       }
//       setIsOpen(false);
//     }
//   };

//   // Handle input blur
//   const handleInputBlur = () => {
//     if (!inputValue) {
//       setIsTyping(false);
//       return;
//     }

//     let parsedDate = parseInputDate(inputValue);

//     // If invalid, try auto-correction
//     if (!parsedDate) {
//       const existingDate = !range
//         ? selectedDate
//         : selectionMode === "from"
//           ? fromDate
//           : toDate;
//       parsedDate = autoCorrectDate(inputValue, showTime, existingDate);
//       if (parsedDate) {
//         const correctedFormat = formatDate(parsedDate);
//         setInputValue(correctedFormat);
//       }
//     } else if (showTime) {
//       // Apply current time to parsed date
//       let hrs = parseInt(hours, 10);
//       if (period === "PM" && hrs !== 12) hrs += 12;
//       if (period === "AM" && hrs === 12) hrs = 0;

//       parsedDate = new Date(
//         parsedDate.getFullYear(),
//         parsedDate.getMonth(),
//         parsedDate.getDate(),
//         hrs,
//         parseInt(minutes, 10),
//       );
//     }

//     if (parsedDate) {
//       if (!range) {
//         setSelectedDate(parsedDate);
//         onChange(parsedDate);
//       } else {
//         if (selectionMode === "from") {
//           setFromDate(parsedDate);
//           setSelectionMode("to");
//           onChange({ from: parsedDate, to: toDate });
//         } else {
//           setToDate(parsedDate);
//           setSelectionMode("from");
//           onChange({ from: fromDate, to: parsedDate });
//         }
//       }
//       setIsTyping(false);
//     } else {
//       // Invalid input that couldn't be corrected - revert to previous value
//       setIsTyping(false);
//       if (!range) {
//         setInputValue(selectedDate ? formatDate(selectedDate) : "");
//       } else {
//         setInputValue("");
//       }
//     }
//   };

//   // Handle paste events
//   const handlePaste = (e) => {
//     e.preventDefault();
//     const pastedText = (e.clipboardData || window.clipboardData).getData(
//       "text",
//     );

//     // Try to auto-correct pasted date
//     const correctedDate = autoCorrectDate(pastedText);
//     if (correctedDate) {
//       const formattedDate = formatDate(correctedDate);
//       setInputValue(formattedDate);
//       setIsTyping(false);

//       if (!range) {
//         setSelectedDate(correctedDate);
//         onChange(correctedDate);
//       } else {
//         if (selectionMode === "from") {
//           setFromDate(correctedDate);
//           setSelectionMode("to");
//           onChange({ from: correctedDate, to: toDate });
//         } else {
//           setToDate(correctedDate);
//           setSelectionMode("from");
//           onChange({ from: fromDate, to: correctedDate });
//         }
//       }
//     } else {
//       // If can't auto-correct, just format what we can
//       const formatted = formatInput(pastedText);
//       setInputValue(formatted);
//       setIsTyping(true);
//     }
//   };

//   // Update input value when dates change externally
//   useEffect(() => {
//     if (!isTyping) {
//       if (range) {
//         setInputValue("");
//       } else {
//         setInputValue(selectedDate ? formatDate(selectedDate) : "");
//       }
//     }
//   }, [selectedDate, fromDate, toDate, isTyping, range]);

//   // Get display value for input
//   //   const getDisplayValue = () => {
//   //     // When user is actively typing, show the raw input
//   //     if (isTyping) {
//   //       return inputValue;
//   //     }

//   //     // When not typing, show formatted display values
//   //     if (range) {
//   //       return formatDateRange();
//   //     } else {
//   //       return showTime && selectedDate
//   //         ? formatDateWithTime(selectedDate, hours, minutes, period)
//   //         : selectedDate
//   //         ? formatDateReadable(selectedDate)
//   //         : "";
//   //     }
//   //   };
//   const getDisplayValue = () => {
//     if (isTyping) return inputValue;

//     // Show preset label ONLY if not custom
//     if (selectedPreset && selectedPreset.value !== 12) {
//       return selectedPreset.label;
//     }

//     // if (range && fromDate && toDate) {
//     //   return `${formatDateReadable(fromDate)} - ${formatDateReadable(toDate)}`;
//     // }
//     if (range && fromDate && toDate) {
//       // If both are today → show only "Today"
//       if (isToday(fromDate) && isToday(toDate)) {
//         return "Today";
//       }

//       // If same date (not today)
//       // if (isSameDay(fromDate, toDate)) {
//       //   return formatDateReadable(fromDate);
//       // }

//       return `${formatDateReadable(fromDate)} - ${formatDateReadable(toDate)}`;
//     }

//     if (range && fromDate) {
//       return `${formatDateReadable(fromDate)} - Select end date`;
//     }

//     if (showTime && selectedDate) {
//       return formatDateWithTime(selectedDate, hours, minutes, period);
//     }

//     if (selectedDate) {
//       return formatDateReadable(selectedDate);
//     }

//     return "";
//   };

//   const daysInMonth = (month, year) => {
//     return new Date(year, month, 0).getDate();
//   };

//   const isDateValid = (date) => {
//     if (!date) return false;
//     if (minDate && date < minDate) return false;
//     if (maxDate && date > maxDate) return false;
//     if (range && selectionMode === "to" && fromDate && date < fromDate)
//       return false;
//     return true;
//   };

//   useEffect(() => {
//     if (selected) {
//       setFromDate(parseDate(range ? selected?.from || selected?.start : null));
//       setToDate(parseDate(range ? selected?.to || selected?.end : null));
//     }
//   }, [selected]);

//   useEffect(() => {
//     if (!range) {
//       const parsedDate = parseDate(selected);
//       if (parsedDate && isDateValid(parsedDate)) {
//         setSelectedDate(parsedDate);
//         setCurrentDate(parsedDate);
//       }
//     } else {
//       const parsedFromDate = parseDate(selected?.from || selected?.start);
//       const parsedToDate = parseDate(selected?.to || selected?.end);

//       if (parsedFromDate) {
//         setFromDate(parsedFromDate);
//         setSelectionMode(parsedToDate ? "from" : "to");
//         if (!currentDate || selectionMode === "from") {
//           setCurrentDate(new Date(parsedFromDate));
//         }
//       }

//       if (parsedToDate) {
//         setToDate(parsedToDate);
//         if (selectionMode === "to") {
//           setCurrentDate(new Date(parsedToDate));
//         }
//       }
//     }
//   }, [selected, minDate, maxDate, range]);

//   const handleDayClick = (day) => {
//     setSelectedPreset(null);
//     try {
//       let finalHours = 0;
//       let finalMinutes = 0;

//       if (showTime) {
//         finalHours = parseInt(hours, 10);
//         if (period === "PM" && finalHours !== 12) {
//           finalHours += 12;
//         }
//         if (period === "AM" && finalHours === 12) {
//           finalHours = 0;
//         }
//         finalMinutes = parseInt(minutes, 10);
//       }

//       const newSelectedDate = new Date(
//         currentDate.getFullYear(),
//         currentDate.getMonth(),
//         day,
//         finalHours,
//         finalMinutes,
//         0,
//         0,
//       );

//       if (isDateValid(newSelectedDate) && !isNaN(newSelectedDate)) {
//         if (!range) {
//           setTempSelectedDate(newSelectedDate);
//           setSelectedDate(newSelectedDate);
//           onChange(formatDateToLocalISO(newSelectedDate)); // CHANGED: format before sending
//           setIsOpen(false);
//         } else {
//           if (selectionMode === "from") {
//             // if (toDate && newSelectedDate > toDate) {
//             //   setToDate(null);
//             //   setFromDate(newSelectedDate);
//             //   setSelectionMode("to");
//             //   onChange({ from: newSelectedDate, to: null });
//             // } else {
//             //   setFromDate(newSelectedDate);
//             //   setSelectionMode("to");
//             //   onChange({ from: newSelectedDate, to: toDate });
//             // }
//             setFromDate(newSelectedDate);
//             setToDate(null);
//             setSelectionMode("to");
//             onChange({ from: formatDateToLocalISO(newSelectedDate), to: null }); // CHANGED
//           } else {
//             setToDate(newSelectedDate);
//             setSelectionMode("from");
//             onChange({
//               from: formatDateToLocalISO(fromDate),
//               to: formatDateToLocalISO(newSelectedDate),
//             });
//             setIsOpen(false);
//           }
//           setTempSelectedDate(newSelectedDate);
//         }
//       }
//     } catch (error) {
//       console.error("Error creating date:", error);
//     }
//   };

//   const handlePrevMonth = () => {
//     const prevMonth = new Date(
//       currentDate.setMonth(currentDate.getMonth() - 1),
//     );
//     setCurrentDate(new Date(prevMonth));
//   };

//   const handleNextMonth = () => {
//     const nextMonth = new Date(
//       currentDate.setMonth(currentDate.getMonth() + 1),
//     );
//     setCurrentDate(new Date(nextMonth));
//   };

//   const handleTodayClick = () => {
//     const today = new Date();

//     if (showTime) {
//       let hrs = parseInt(hours, 10);
//       if (period === "PM" && hrs !== 12) hrs += 12;
//       if (period === "AM" && hrs === 12) hrs = 0;
//       today.setHours(hrs, parseInt(minutes, 10), 0, 0);
//     } else {
//       today.setHours(0, 0, 0, 0);
//     }

//     setTempSelectedDate(today);
//     setCurrentDate(today);

//     if (!range) {
//       setSelectedDate(today);
//       onChange(formatDateToLocalISO(today));
//     } else {
//       if (selectionMode === "from") {
//         setFromDate(today);
//         setSelectionMode("to");
//         onChange({
//           from: formatDateToLocalISO(today),
//           to: toDate ? formatDateToLocalISO(toDate) : null,
//         });
//       } else {
//         setToDate(today);
//         setSelectionMode("from");
//         onChange({
//           from: formatDateToLocalISO(fromDate),
//           to: formatDateToLocalISO(today),
//         });
//       }
//     }
//     setIsOpen(false);
//   };

//   const handleDoneClick = () => {
//     if (!range) {
//       if (tempSelectedDate) {
//         setSelectedDate(tempSelectedDate);
//         try {
//           if (typeof onChange === "function") {
//             onChange(tempSelectedDate);
//           }
//         } catch (error) {
//           console.error("Error in onChange handler:", error);
//         }
//       }
//     } else {
//       if (tempSelectedDate) {
//         if (selectionMode === "from") {
//           setFromDate(tempSelectedDate);
//           setSelectionMode("to");
//           onChange({ from: tempSelectedDate, to: toDate });
//         } else {
//           setToDate(tempSelectedDate);
//           setSelectionMode("from");
//           onChange({ from: fromDate, to: tempSelectedDate });
//           setIsOpen(false);
//         }
//       }

//       if (selectionMode === "to" && fromDate && !tempSelectedDate) {
//         setIsOpen(false);
//       }
//     }

//     setIsOpen(false);
//     setShowMonthsList(false);
//     setShowYearsList(false);
//   };

//   const handleClearClick = () => {
//     if (!range) {
//       setSelectedDate(null);
//       onChange(null);
//     } else {
//       setFromDate(null);
//       setToDate(null);
//       setSelectionMode("from");
//       onChange({ from: null, to: null });
//     }
//     setInputValue("");
//     setIsTyping(false);
//     setIsOpen(false);
//   };

//   const handleIconClick = (e) => {
//     e.stopPropagation();
//     if (range) {
//       if (fromDate || toDate) {
//         setFromDate(null);
//         setToDate(null);
//         setSelectionMode("from");
//         onChange({ from: null, to: null });
//         setInputValue("");
//         setIsTyping(false);
//       }
//     } else {
//       if (selectedDate) {
//         setSelectedDate(null);
//         onChange(null);
//         setInputValue("");
//         setIsTyping(false);
//       }
//     }
//   };

//   const handleTimeChange = (type, value) => {
//     if (type === "hours") setHours(value);
//     if (type === "minutes") setMinutes(value);
//     if (type === "period") setPeriod(value);

//     // Update the selected date with new time
//     if (selectedDate && !range) {
//       let hrs = type === "hours" ? parseInt(value, 10) : parseInt(hours, 10);
//       const mins =
//         type === "minutes" ? parseInt(value, 10) : parseInt(minutes, 10);
//       const per = type === "period" ? value : period;

//       if (per === "PM" && hrs !== 12) hrs += 12;
//       if (per === "AM" && hrs === 12) hrs = 0;

//       const updatedDate = new Date(
//         selectedDate.getFullYear(),
//         selectedDate.getMonth(),
//         selectedDate.getDate(),
//         hrs,
//         mins,
//         0,
//         0,
//       );

//       setSelectedDate(updatedDate);
//       onChange(formatDateToLocalISO(updatedDate));
//     }
//   };

//   useEffect(() => {
//     const handleKeyDownGlobal = (e) => {
//       if (!isOpen && !showMonthsList && !showYearsList) return;

//       switch (e.key) {
//         case "Escape":
//           setIsOpen(false);
//           setShowMonthsList(false);
//           setShowYearsList(false);
//           break;
//         case "ArrowLeft":
//           if (!showMonthsList && !showYearsList) handlePrevMonth();
//           break;
//         case "ArrowRight":
//           if (!showMonthsList && !showYearsList) handleNextMonth();
//           break;
//         case "Enter":
//           if (showMonthsList) {
//             setShowMonthsList(false);
//             setIsOpen(true);
//           } else if (showYearsList) {
//             setShowYearsList(false);
//             setIsOpen(true);
//           }
//           break;
//         default:
//           break;
//       }
//     };

//     document.addEventListener("keydown", handleKeyDownGlobal);
//     return () => document.removeEventListener("keydown", handleKeyDownGlobal);
//   }, [isOpen, showMonthsList, showYearsList]);

//   const renderCalendar = () => {
//     const firstDayOfMonth = new Date(
//       currentDate.getFullYear(),
//       currentDate.getMonth(),
//       1,
//     ).getDay();
//     const daysInCurrentMonth = daysInMonth(
//       currentDate.getMonth() + 1,
//       currentDate.getFullYear(),
//     );
//     const days = [];

//     const prevMonthDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
//     const prevMonth = new Date(
//       currentDate.getFullYear(),
//       currentDate.getMonth(),
//       0,
//     );
//     const prevMonthDaysCount = prevMonth.getDate();

//     for (
//       let i = prevMonthDaysCount - prevMonthDays;
//       i <= prevMonthDaysCount;
//       i++
//     ) {
//       days.push({ day: i, isPrevMonth: true });
//     }

//     for (let i = 1; i <= daysInCurrentMonth; i++) {
//       days.push({ day: i, isPrevMonth: false });
//     }

//     const totalDays = days.length;
//     const missingDays = totalDays % 7;
//     if (missingDays !== 0) {
//       for (let i = 1; i <= 7 - missingDays; i++) {
//         days.push({ day: i, isPrevMonth: false, isNextMonth: true });
//       }
//     }

//     return days.map((item, index) => {
//       const date = new Date(
//         currentDate.getFullYear(),
//         item.isPrevMonth
//           ? currentDate.getMonth() - 1
//           : item.isNextMonth
//             ? currentDate.getMonth() + 1
//             : currentDate.getMonth(),
//         item.day,
//       );

//       const isCurrentDay = date.toDateString() === new Date().toDateString();
//       const isBeforeMinDate = minDate && date < minDate;
//       const isAfterMaxDate = maxDate && date > maxDate;
//       const isBeforeFromDate =
//         range && selectionMode === "to" && fromDate && date < fromDate;

//       const isBlockedDate = normalizedBlockedDates.includes(
//         date.toDateString(),
//       );

//       const isFromDate =
//         range &&
//         fromDate &&
//         date.getDate() === fromDate.getDate() &&
//         date.getMonth() === fromDate.getMonth() &&
//         date.getFullYear() === fromDate.getFullYear() &&
//         !item.isPrevMonth &&
//         !item.isNextMonth;

//       const isToDate =
//         range &&
//         toDate &&
//         date.getDate() === toDate.getDate() &&
//         date.getMonth() === toDate.getMonth() &&
//         date.getFullYear() === toDate.getFullYear() &&
//         !item.isPrevMonth &&
//         !item.isNextMonth;

//       const isInRange =
//         range &&
//         fromDate &&
//         toDate &&
//         date > fromDate &&
//         date < toDate &&
//         !item.isPrevMonth &&
//         !item.isNextMonth;

//       const isSelectedDay =
//         !range &&
//         tempSelectedDate instanceof Date &&
//         !isNaN(tempSelectedDate) &&
//         tempSelectedDate.getDate() === item.day &&
//         tempSelectedDate.getMonth() === currentDate.getMonth() &&
//         tempSelectedDate.getFullYear() === currentDate.getFullYear() &&
//         !item.isPrevMonth &&
//         !item.isNextMonth;

//       const isPrevMonthDay = item.isPrevMonth;
//       const isNextMonthDay = item.isNextMonth;

//       return (
//         <div
//           key={index}
//           className={`leading-none flex items-center justify-center rounded-full ${
//             item.day ? "cursor-pointer" : "cursor-default"
//           } p-2 w-7 h-7 text-center  ${
//             isSelectedDay ? "bg-primary-600 text-white" : ""
//           } ${isFromDate ? "bg-primary-600 text-white" : ""} ${
//             isToDate ? "bg-primary-600 text-white" : ""
//           } ${isInRange && !isBlockedDate ? "bg-primary-100" : ""} ${
//             isCurrentDay ? "border-[1px] border-primary-600" : ""
//           } ${
//             isBlockedDate
//               ? "text-gray-300 cursor-not-allowed hover:cursor-not-allowed hover:text-gray-300 line-through decoration-gray-400"
//               : "hover:bg-primary-600 hover:text-white"
//           }
//           ${
//             isBeforeMinDate || isAfterMaxDate || isBeforeFromDate
//               ? "text-gray-300"
//               : ""
//           } ${fontSizeDatesClasses[size]} ${
//             isPrevMonthDay || isNextMonthDay
//               ? "text-gray-300 cursor-default hover:bg-transparent hover:text-gray-300"
//               : ""
//           }`}
//           onClick={() =>
//             item.day &&
//             !isBeforeMinDate &&
//             !isAfterMaxDate &&
//             !isBeforeFromDate &&
//             !isPrevMonthDay &&
//             !isNextMonthDay &&
//             !isBlockedDate &&
//             handleDayClick(item.day)
//           }
//         >
//           {item.day || ""}
//         </div>
//       );
//     });
//   };

//   // useEffect(() => {
//   //   function handleClickOutside(event) {
//   //     // Check if click is inside the dropdownRef (button) or the dropdownContainerRef (portal dropdown)
//   //     if (
//   //       (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
//   //       (dropdownContainerRef.current &&
//   //         dropdownContainerRef.current.contains(event.target))
//   //     ) {
//   //       return;
//   //     }

//   //     setIsOpen(false);
//   //     setShowMonthsList(false);
//   //     setShowYearsList(false);
//   //   }
//   //   document.addEventListener("mousedown", handleClickOutside);
//   //   return () => document.removeEventListener("mousedown", handleClickOutside);
//   // }, []);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       //   if (
//       //     (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
//       //     (dropdownContainerRef.current &&
//       //       dropdownContainerRef.current.contains(event.target))
//       //   ) {
//       //     return;
//       //   }
//       if (
//         dropdownRef.current?.contains(event.target) ||
//         dropdownContainerRef.current?.contains(event.target) ||
//         isOpen
//       ) {
//         return;
//       }

//       const selectRoot = document.querySelector(".select-root");
//       if (selectRoot && selectRoot.contains(event.target)) {
//         return;
//       }

//       setIsOpen(false);
//       setIsDropdownOpen(false);
//       setShowMonthsList(false);
//       setShowYearsList(false);
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (isOpen) {
//       if (!range) {
//         setTempSelectedDate(selectedDate);
//       } else {
//         setTempSelectedDate(selectionMode === "from" ? fromDate : toDate);
//       }
//     }
//   }, [isOpen, selectedDate, selectionMode, fromDate, toDate, range]);

//   // Position dropdown using portal
//   // useLayoutEffect(() => {
//   //   if (
//   //     (isOpen || showMonthsList || showYearsList) &&
//   //     buttonRef.current &&
//   //     dropdownContainerRef.current
//   //   ) {
//   //     const buttonRect = buttonRef.current.getBoundingClientRect();
//   //     const dropdownContainer = dropdownContainerRef.current;

//   //     dropdownContainer.style.top = `${buttonRect.bottom + window.scrollY}px`;
//   //     dropdownContainer.style.left = `${buttonRect.left + window.scrollX}px`;
//   //   }
//   // }, [isOpen, showMonthsList, showYearsList]);

//   // Replace the existing useLayoutEffect in CustomDatePicker (around lines 775-784) with this:

//   useLayoutEffect(() => {
//     if (
//       (isOpen || showMonthsList || showYearsList) &&
//       buttonRef.current &&
//       dropdownContainerRef.current
//     ) {
//       const updatePosition = () => {
//         const buttonRect = buttonRef.current.getBoundingClientRect();
//         const dropdownRect =
//           dropdownContainerRef.current.getBoundingClientRect();
//         const viewportHeight = window.innerHeight;
//         const viewportWidth = window.innerWidth;

//         // Calculate available space
//         const spaceBelow = viewportHeight - buttonRect.bottom;
//         const spaceAbove = buttonRect.top;

//         // Determine if dropdown should be below or above button
//         const showBelow =
//           spaceBelow >= Math.min(320, dropdownRect.height) ||
//           spaceBelow >= spaceAbove;

//         // Calculate left position
//         let left = buttonRect.left + window.scrollX;
//         // Adjust if dropdown would overflow right edge
//         if (left + dropdownRect.width > viewportWidth) {
//           left = Math.max(0, viewportWidth - dropdownRect.width);
//         }

//         // Calculate top position
//         let top;
//         if (showBelow) {
//           top = buttonRect.bottom + window.scrollY + 8; // Add 8px gap
//           // Check if dropdown extends beyond bottom of viewport
//           if (top + dropdownRect.height > viewportHeight + window.scrollY) {
//             top = viewportHeight + window.scrollY - dropdownRect.height - 8;
//           }
//         } else {
//           top = buttonRect.top + window.scrollY - dropdownRect.height - 8; // Add 8px gap above
//           // Check if dropdown extends beyond top of viewport
//           if (top < window.scrollY) {
//             top = window.scrollY + 8;
//           }
//         }

//         // Apply the calculated position
//         dropdownContainerRef.current.style.left = `${left}px`;
//         dropdownContainerRef.current.style.top = `${top}px`;
//       };

//       // Initial position update
//       updatePosition();

//       // Update position on scroll and resize
//       const handleScroll = () => {
//         requestAnimationFrame(updatePosition);
//       };

//       // Add scroll event listeners
//       window.addEventListener("scroll", handleScroll, true);
//       window.addEventListener("resize", handleScroll);

//       // Cleanup
//       return () => {
//         window.removeEventListener("scroll", handleScroll, true);
//         window.removeEventListener("resize", handleScroll);
//       };
//     }
//   }, [isOpen, showMonthsList, showYearsList]);
//   // const getDateRangeByOption = (value) => {
//   //   const now = new Date();
//   //   let startDate = null;
//   //   let endDate = new Date(now);

//   //   // Normalize end date to now
//   //   endDate.setHours(23, 59, 59, 999);

//   //   switch (value) {
//   //     // Today
//   //     case 1: {
//   //       startDate = new Date(now);
//   //       startDate.setHours(0, 0, 0, 0);

//   //       break;
//   //     }

//   //     // Yesterday
//   //     case 2: {
//   //       startDate = new Date(now);
//   //       startDate.setDate(startDate.getDate() - 1);
//   //       startDate.setHours(0, 0, 0, 0);

//   //       endDate = new Date(startDate);
//   //       endDate.setHours(23, 59, 59, 999);
//   //       break;
//   //     }

//   //     // This Week (Monday → today)
//   //     case 3: {
//   //       const day = now.getDay(); // 0 = Sunday
//   //       const diff = day === 0 ? 6 : day - 1; // make Monday first day

//   //       startDate = new Date(now);
//   //       startDate.setDate(now.getDate() - diff);
//   //       startDate.setHours(0, 0, 0, 0);
//   //       break;
//   //     }

//   //     // Last Week (Monday → Sunday)
//   //     case 4: {
//   //       const day = now.getDay();
//   //       const diff = day === 0 ? 6 : day - 1;

//   //       startDate = new Date(now);
//   //       startDate.setDate(now.getDate() - diff - 7);
//   //       startDate.setHours(0, 0, 0, 0);

//   //       endDate = new Date(startDate);
//   //       endDate.setDate(startDate.getDate() + 6);
//   //       endDate.setHours(23, 59, 59, 999);
//   //       break;
//   //     }

//   //     // Fortnight (Last 15 days including today)
//   //     case 5: {
//   //       startDate = new Date(now);
//   //       startDate.setDate(now.getDate() - 14);
//   //       startDate.setHours(0, 0, 0, 0);
//   //       break;
//   //     }

//   //     // This Month
//   //     case 6: {
//   //       startDate = new Date(now.getFullYear(), now.getMonth(), 1);
//   //       startDate.setHours(0, 0, 0, 0);
//   //       break;
//   //     }

//   //     // Last Month
//   //     case 7: {
//   //       startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
//   //       startDate.setHours(0, 0, 0, 0);

//   //       endDate = new Date(now.getFullYear(), now.getMonth(), 0);
//   //       endDate.setHours(23, 59, 59, 999);
//   //       break;
//   //     }

//   //     // Last 3 Months (rolling)
//   //     case 8: {
//   //       startDate = new Date(now);
//   //       startDate.setMonth(now.getMonth() - 3);
//   //       startDate.setHours(0, 0, 0, 0);
//   //       break;
//   //     }

//   //     // Last 6 Months (rolling)
//   //     case 9: {
//   //       startDate = new Date(now);
//   //       startDate.setMonth(now.getMonth() - 6);
//   //       startDate.setHours(0, 0, 0, 0);
//   //       break;
//   //     }

//   //     // This Year
//   //     case 10: {
//   //       startDate = new Date(now.getFullYear(), 0, 1);
//   //       startDate.setHours(0, 0, 0, 0);
//   //       break;
//   //     }

//   //     // Last Year
//   //     case 11: {
//   //       startDate = new Date(now.getFullYear() - 1, 0, 1);
//   //       startDate.setHours(0, 0, 0, 0);

//   //       endDate = new Date(now.getFullYear() - 1, 11, 31);
//   //       endDate.setHours(23, 59, 59, 999);
//   //       break;
//   //     }

//   //     // Custom Range
//   //     case 12: {
//   //       setIsOpen(true);
//   //       return null;
//   //     }
//   //     /// Single Date (Today)
//   //     case 13: {
//   //       const today = new Date();
//   //       today.setHours(0, 0, 0, 0);
//   //       return today;
//   //     }
//   //     /// Single Date (Yesterday)
//   //     case 14: {
//   //       const now = new Date();
//   //       const yesterday = new Date(
//   //         now.getFullYear(),
//   //         now.getMonth(),
//   //         now.getDate() - 1
//   //       );
//   //       return yesterday;
//   //     }

//   //     default:
//   //       return null;
//   //   }

//   //   return { startDate, endDate };
//   // };

//   const handleOptionSelect = (option) => {
//     // Check if option is disabled
//     if (
//       option.value !== 12 &&
//       isOptionDisabled(option.value, minDate, normalizedBlockedDates)
//     ) {
//       return;
//     }

//     setIsDropdownOpen(false);
//     setShowMonthsList(false);
//     setShowYearsList(false);

//     // Custom range
//     if (option.value === 12) {
//       setSelectedPreset(null);
//       setSelectionMode("from");
//       setTimeout(() => setIsOpen(true), 0);
//       return;
//     }

//     const result = getDateByOption(option.value);
//     // SINGLE DATE MODE
//     if (!range && result instanceof Date) {
//       console.log("result", result);
//       setSelectedDate(result);
//       setCurrentDate(result);
//       setSelectedPreset(option);

//       onChange(formatDateToLocalISO(result));
//       setIsOpen(false);
//       return;
//     }

//     //  RANGE MODE
//     if (range && result?.startDate) {
//       setFromDate(result.startDate);
//       setToDate(result.endDate);
//       setSelectionMode("from");
//       setSelectedPreset(option);

//       onChange({
//         from: formatDateToLocalISO(result.startDate),
//         to: formatDateToLocalISO(result.endDate),
//       });

//       setIsOpen(false);
//     }
//   };
//   const isOptionDisabled = (optionValue, minDate, normalizedBlockedDates) => {
//     const result = getDateByOption(optionValue);
//     // For single date options (Today, Yesterday)
//     if (result instanceof Date) {
//       const resultDateStr = result.toDateString();

//       // Check if date is before minDate
//       if (minDate) {
//         const minDateNormalized = new Date(minDate);
//         minDateNormalized.setHours(0, 0, 0, 0);
//         const resultNormalized = new Date(result);
//         resultNormalized.setHours(0, 0, 0, 0);

//         if (resultNormalized < minDateNormalized) {
//           return true;
//         }
//       }

//       // Check if date is in blocked dates
//       if (normalizedBlockedDates.includes(resultDateStr)) {
//         return true;
//       }
//     }

//     // For range options (This Week, Last Week, etc.)
//     if (result?.startDate && result?.endDate) {
//       const start = new Date(result.startDate);
//       const end = new Date(result.endDate);

//       // Check if entire range is blocked
//       let allBlocked = true;
//       let current = new Date(start);

//       while (current <= end) {
//         const currentDateStr = current.toDateString();
//         if (!normalizedBlockedDates.includes(currentDateStr)) {
//           allBlocked = false;
//           break;
//         }
//         current.setDate(current.getDate() + 1);
//       }

//       if (allBlocked) {
//         return true;
//       }
//     }

//     return false;
//   };
//   return (
//     <div className="relative w-full min-w-32" ref={dropdownRef}>
//       <div
//         ref={buttonRef}
//         className={`w-full border flex justify-between items-center ${
//           fontSizeClasses[size]
//         } ${rounded}
//         ${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}
//         ${
//           disabled
//             ? "border-neutrals-200 cursor-not-allowed bg-neutrals-200 text-black"
//             : "bg-white hover:border-primary-600 focus-within:border-primary-600 focus-within:outline-none"
//         }`}
//       >
//         <input
//           ref={inputRef}
//           className={`w-full bg- border-0 text-black focus:outline-none ${rounded} ${
//             sizeClasses[size]
//           } ${fontSizeClasses[size]} ${
//             disabled ? "bg-neutrals-200 cursor-not-allowed" : " bg-white"
//           }`}
//           onClick={() => {
//             if (showMonthsList || showYearsList) {
//               setShowMonthsList(false);
//               setShowYearsList(false);
//             }
//             if (range && showDropdown) {
//               // if (!isDropdownOpen) {
//               setIsOpen(false);
//               setIsDropdownOpen(true);
//               // }
//             } else if (!range && showDropdown) {
//               // if (!isDropdownOpen) {
//               setIsOpen(false);
//               setIsDropdownOpen(true);
//               // }
//             } else {
//               setIsOpen(!isOpen);
//             }
//           }}
//           onChange={handleInputChange}
//           onKeyDown={handleKeyDown}
//           onBlur={handleInputBlur}
//           onPaste={handlePaste}
//           disabled={disabled}
//           placeholder={placeholder}
//           value={getDisplayValue()}
//           maxLength={range ? 100 : 10} // Allow longer input for ranges
//         />
//         {isDropdownOpen && (
//           <div className="absolute left-0 top-full mt-1 w-full max-h-60 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg z-[55]">
//             {optionsToShow?.map((option) => {
//               // Check if this option should be disabled
//               const isDisabled =
//                 option.value !== 12 &&
//                 isOptionDisabled(option.value, minDate, normalizedBlockedDates);

//               return (
//                 <div
//                   key={option.value}
//                   className={`px-3 py-2 ${
//                     isDisabled
//                       ? "cursor-not-allowed bg-gray-100 text-gray-400"
//                       : "cursor-pointer hover:bg-gray-100"
//                   }`}
//                   onMouseDown={(e) => {
//                     if (isDisabled) {
//                       e.preventDefault();
//                       e.stopPropagation();
//                       return;
//                     }
//                     e.stopPropagation();
//                     handleOptionSelect(option);
//                   }}
//                 >
//                   {option.label}
//                 </div>
//               );
//             })}
//           </div>
//         )}

//         <span
//           className={`mx-2 material-icons transition-transform ${
//             iconSizeClasses[size]
//           } ${
//             disabled
//               ? "cursor-not-allowed bg-neutrals-200 text-black"
//               : "cursor-pointer"
//           }`}
//           onClick={(e) => {
//             if (disabled) return;

//             if (range ? fromDate || toDate : selectedDate) {
//               handleIconClick(e);
//               setSelectedPreset(null);
//             } else {
//               e.stopPropagation();
//               if (showMonthsList || showYearsList) {
//                 setShowMonthsList(false);
//                 setShowYearsList(false);
//               }
//               // setIsOpen(!isOpen);
//               if (range && showDropdown) {
//                 // if (!isDropdownOpen) {
//                 setIsDropdownOpen(true);
//                 // }
//               } else if (!range && showDropdown) {
//                 // if (!isDropdownOpen) {
//                 setIsDropdownOpen(true);
//                 // }
//               } else {
//                 setIsOpen(!isOpen);
//               }
//             }
//           }}
//         >
//           {(range ? fromDate || toDate : selectedDate)
//             ? "close"
//             : "calendar_month"}
//         </span>
//       </div>

//       {isOpen &&
//         createPortal(
//           <div
//             ref={dropdownContainerRef}
//             style={{
//               position: "fixed",
//               width: buttonRef.current?.offsetWidth,
//             }}
//             className="z-[55] bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-80"
//           >
//             <div className="px-4 pt-3 flex justify-between items-center">
//               <div className="flex items-center gap-1 border-[1px] border-gray-100 p-1 px-1">
//                 <Button
//                   type="icon"
//                   color="black"
//                   variant="text"
//                   size="sm"
//                   icon={"west"}
//                   onClick={handlePrevMonth}
//                 />

//                 <div>
//                   <Button
//                     variant="text"
//                     size="sm"
//                     color="black"
//                     title={fullMonths[currentDate.getMonth()]}
//                     onClick={() => {
//                       if (showMonthsList) {
//                         setShowMonthsList(false);
//                         setIsOpen(true);
//                       } else {
//                         setShowMonthsList(true);
//                         setShowYearsList(false);
//                         setIsOpen(false);
//                       }
//                     }}
//                   />
//                 </div>

//                 <Button
//                   type="icon"
//                   variant="text"
//                   size="sm"
//                   color="black"
//                   icon={"east"}
//                   onClick={handleNextMonth}
//                 />
//               </div>
//               <div className="border-[1px] border-gray-100 p-1 px-3">
//                 <Button
//                   variant="text"
//                   size="sm"
//                   color="black"
//                   title={currentDate.getFullYear()}
//                   onClick={() => {
//                     if (showYearsList) {
//                       setShowYearsList(false);
//                       setIsOpen(true);
//                     } else {
//                       setShowYearsList(true);
//                       setShowMonthsList(false);
//                       setIsOpen(false);
//                     }
//                   }}
//                 />
//               </div>
//             </div>

//             {range && (
//               <div className="px-4 pt-2">
//                 <div className="text-sm font-medium text-primary-600">
//                   {selectionMode === "from"
//                     ? "Select start date"
//                     : "Select end date"}
//                 </div>
//               </div>
//             )}

//             <div className="grid grid-cols-7 place-items-center gap-1 px-2 py-4">
//               {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
//                 <div
//                   key={day}
//                   className={`flex justify-center items-center w-7 h-7 ${fontSizeDatesClasses[size]}`}
//                 >
//                   {day[0]}
//                 </div>
//               ))}
//               {renderCalendar()}
//             </div>

//             {showTime && (
//               <div
//                 className="border-t border-gray-200 px-2"
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <h3 className="text-sm font-semibold">Select Time</h3>

//                 <div className="grid grid-cols-3 gap-3 mb-3">
//                   <div>
//                     <FormFieldSet
//                       type="select"
//                       noTitle={false}
//                       title="Hours"
//                       placeholder="HH"
//                       size="sm"
//                       options={hoursArray}
//                       value={hours}
//                       onChange={(value) => handleTimeChange("hours", value)}
//                     />
//                   </div>

//                   <div>
//                     <FormFieldSet
//                       type="select"
//                       noTitle={false}
//                       title="Minutes"
//                       placeholder="MM"
//                       size="sm"
//                       options={minutesArray}
//                       value={minutes}
//                       onChange={(value) => handleTimeChange("minutes", value)}
//                     />
//                   </div>

//                   <div>
//                     <FormFieldSet
//                       type="select"
//                       noTitle={false}
//                       title="Period"
//                       placeholder="AM/PM"
//                       size="sm"
//                       options={periodArray}
//                       value={period}
//                       onChange={(value) => handleTimeChange("period", value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             )}
//             {/* <hr />
//             <div className="flex items-center justify-between px-4 py-4">
//               <Button
//                 variant="text"
//                 color="black"
//                 title="Clear"
//                 onClick={handleClearClick}
//               />
//               <div className="flex items-center gap-2">
//                 <Button
//                   variant="text"
//                   color="black"
//                   title="Today"
//                   onClick={handleTodayClick}
//                 />
//                 <Button title="Done" size="md" onClick={handleDoneClick} />
//               </div>
//             </div> */}
//           </div>,
//           document.querySelector(".select-root"),
//         )}

//       {showMonthsList &&
//         createPortal(
//           <div
//             ref={dropdownContainerRef}
//             style={{
//               position: "fixed",
//               width: buttonRef.current?.offsetWidth,
//             }}
//             className="z-[55] p-4 bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-80"
//           >
//             <div className="grid grid-cols-3 gap-4">
//               {fullMonths.map((month, index) => (
//                 <Button
//                   key={index}
//                   variant={
//                     month === fullMonths[currentDate.getMonth()]
//                       ? "outlined"
//                       : "text"
//                   }
//                   color={
//                     month === fullMonths[currentDate.getMonth()]
//                       ? "primary"
//                       : "black"
//                   }
//                   title={month.slice(0, 3)}
//                   onClick={() => {
//                     setCurrentDate(new Date(currentDate.setMonth(index)));
//                     setShowMonthsList(false);
//                     setIsOpen(true);
//                   }}
//                 />
//               ))}
//             </div>
//           </div>,
//           document.querySelector(".select-root"),
//         )}

//       {showYearsList &&
//         createPortal(
//           <div
//             ref={dropdownContainerRef}
//             style={{
//               position: "fixed",
//               width: buttonRef.current?.offsetWidth,
//             }}
//             className="z-[55] p-4 bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-80"
//           >
//             <div className="flex justify-between gap-1 items-center mb-4">
//               <Button
//                 type="icon"
//                 size="xs-sm"
//                 icon={"west"}
//                 onClick={() => {
//                   const { minYear } = getYearLimits();
//                   const newYear = Math.max(
//                     currentDate.getFullYear() - 9,
//                     minYear,
//                   );
//                   setCurrentDate(new Date(currentDate.setFullYear(newYear)));
//                 }}
//               />
//               <span className="text-sm font-medium">
//                 {currentDate.getFullYear()}
//               </span>
//               <Button
//                 type="icon"
//                 size="xs-sm"
//                 icon={"east"}
//                 onClick={() => {
//                   const { maxYear } = getYearLimits();
//                   const newYear = Math.min(
//                     currentDate.getFullYear() + 9,
//                     maxYear,
//                   );
//                   setCurrentDate(new Date(currentDate.setFullYear(newYear)));
//                 }}
//               />
//             </div>
//             <div className="grid grid-cols-3 gap-4">
//               {(() => {
//                 const { minYear, maxYear } = getYearLimits();
//                 const currentYear = currentDate.getFullYear();
//                 const startYear = Math.max(currentYear - 4, minYear);
//                 const endYear = Math.min(startYear + 8, maxYear);
//                 const years = [];

//                 for (let year = startYear; year <= endYear; year++) {
//                   years.push(year);
//                 }

//                 return years.map((year) => (
//                   <Button
//                     key={year}
//                     title={year.toString()}
//                     variant={currentYear === year ? "outlined" : "text"}
//                     color={currentYear === year ? "primary" : "default"}
//                     onClick={() => {
//                       setCurrentDate(new Date(currentDate.setFullYear(year)));
//                       setShowYearsList(false);
//                       setIsOpen(true);
//                       setShowMonthsList(false);
//                     }}
//                   />
//                 ));
//               })()}
//             </div>
//           </div>,
//           document.querySelector(".select-root"),
//         )}
//     </div>
//   );
// };

// export default CustomDatePicker;

import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useMemo,
} from "react";
import { createPortal } from "react-dom";
import Button from "../../Buttons/Button";
import FormFieldSet from "../FormFieldSet";
import {
  datePickerOptions,
  predefinedDatePickerOptions,
  singleDatePickerOptions,
} from "../../../assets/data/enumData";
import { getDateByOption } from "../../../utils/getDateByOption";
const sizeClasses = {
  sm: "px-3 py-1.5",
  md: "px-3 py-2",
  lg: "px-4 py-2.5",
  xl: "px-5 py-3",
};

const fontSizeClasses = {
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const iconSizeClasses = {
  sm: "!text-[14px]",
  md: "!text-[14px]",
  lg: "!text-[15px]",
  xl: "!text-[15px]",
};

const fontSizeDatesClasses = {
  sm: "text-[10px]",
  md: "text-[12px]",
  lg: "text-[14px]",
  xl: "text-[16px]",
};

// Button component mock for demo

const formatDateToLocalISO = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date)) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

const CustomDatePicker = ({
  selected,
  onChange = () => {},
  placeholder = "Select a date",
  size = "md",
  rounded = "rounded",
  maxDate,
  minDate,
  range = false,
  disabled = false,
  blockDates = [],
  shadow = false,
  showTime = false,
  showDropdown = true, //prop to control dropdown visibility
  dropdownOptions = "predefined", //predefined , all
  defaultOption,
}) => {
  const optionsToShow = range
    ? dropdownOptions === "predefined"
      ? predefinedDatePickerOptions
      : datePickerOptions
    : singleDatePickerOptions;

  // Normalize blocked dates to comparable strings
  const normalizedBlockedDates = useMemo(() => {
    const blockedSet = new Set();

    blockDates.forEach((entry) => {
      // Case 1: single date (string or Date)
      if (entry instanceof Date || typeof entry === "string") {
        blockedSet.add(new Date(entry).toDateString());
      }
      // Case 2: range object { from, to }
      else if (entry && entry.from && entry.to) {
        const from = new Date(entry.from);
        const to = new Date(entry.to);

        let current = new Date(from);
        while (current <= to) {
          blockedSet.add(new Date(current).toDateString());
          current.setDate(current.getDate() + 1);
        }
      }
    });

    return Array.from(blockedSet);
  }, [blockDates]);

  const parseDate = (dateInput, preserveTime = false) => {
    if (!dateInput) return null;

    if (typeof dateInput === "string") {
      if (dateInput.includes("T")) {
        const datePart = dateInput.split("T")[0];
        const [year, month, day] = datePart.split("-").map(Number);
        return new Date(year, month - 1, day);
      }

      if (dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateInput.split("-").map(Number);
        return new Date(year, month - 1, day);
      }
    }

    if (dateInput instanceof Date && !isNaN(dateInput)) {
      if (preserveTime || showTime) {
        return new Date(dateInput.getTime());
      }
      return new Date(
        dateInput.getFullYear(),
        dateInput.getMonth(),
        dateInput.getDate(),
      );
    }

    const date = new Date(dateInput);
    return isNaN(date.getTime()) ? null : date;
  };

  const getOptionByLabel = (label, options) => {
    if (!label) return null;
    return options.find(
      (opt) => opt.label.toLowerCase() === label.toLowerCase(),
    );
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedPreset, setSelectedPreset] = useState(null);
  const [currentDate, setCurrentDate] = useState(
    parseDate(range ? selected?.from || selected?.start : selected) ||
      new Date(),
  );
  const [selectedDate, setSelectedDate] = useState(parseDate(selected));
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const dropdownContainerRef = useRef(null);

  // Range mode states
  const [fromDate, setFromDate] = useState(
    parseDate(range ? selected?.from || selected?.start : null),
  );
  const [toDate, setToDate] = useState(
    parseDate(range ? selected?.to || selected?.end : null),
  );
  const [selectionMode, setSelectionMode] = useState(fromDate ? "to" : "from");

  const [showMonthsList, setShowMonthsList] = useState(false);
  const [showYearsList, setShowYearsList] = useState(false);
  const [tempSelectedDate, setTempSelectedDate] = useState(null);

  // New states for typing functionality
  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  // New states for Time
  const [hours, setHours] = useState("12");
  const [minutes, setMinutes] = useState("00");
  const [period, setPeriod] = useState("AM");

  useEffect(() => {
    setSelectedDate(parseDate(selected));
  }, [selected]);

  useEffect(() => {
    if (!selected) return;

    const date = new Date(selected);
    if (isNaN(date.getTime())) return;

    let hrs = date.getHours();
    let mins = date.getMinutes();
    let periodValue = hrs >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hrs = hrs % 12;
    hrs = hrs === 0 ? 12 : hrs;

    setHours(String(hrs).padStart(2, "0"));
    setMinutes(String(mins).padStart(2, "0"));
    setPeriod(periodValue);
  }, [selected, showTime]);

  useEffect(() => {
    if (
      defaultOption &&
      (!selected || (selected?.from === null && selected?.to === null))
    ) {
      let option = null;

      if (!isNaN(defaultOption)) {
        const optionValue = parseInt(defaultOption);
        option = optionsToShow.find((opt) => opt.value === optionValue);
      } else {
        option = getOptionByLabel(defaultOption, optionsToShow);
      }

      if (option && option.value !== 12) {
        const result = getDateByOption(option.value);

        // SINGLE DATE MODE
        if (!range && result instanceof Date) {
          setSelectedDate(result);
          setCurrentDate(result);
          setSelectedPreset(option);
          onChange(formatDateToLocalISO(result));
          return;
        }

        // RANGE MODE
        if (range && result?.startDate) {
          setFromDate(result.startDate);
          setToDate(result.endDate);
          setSelectionMode("from");
          setSelectedPreset(option);

          onChange({
            from: formatDateToLocalISO(result.startDate),
            to: formatDateToLocalISO(result.endDate),
          });
        }
      }
    }
  }, [[defaultOption, selected, range]]);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const fullMonths = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Generate hours array (01-12)
  const hoursArray = Array.from({ length: 12 }, (_, i) => ({
    label: String(i + 1).padStart(2, "0"),
    value: String(i + 1).padStart(2, "0"),
  }));

  // Generate minutes array (00-59)
  const minutesArray = Array.from({ length: 60 }, (_, i) => ({
    label: String(i).padStart(2, "0"),
    value: String(i).padStart(2, "0"),
  }));

  const periodArray = [
    { label: "AM", value: "AM" },
    { label: "PM", value: "PM" },
  ];

  // Get dynamic year limits based on minDate and maxDate
  const getYearLimits = () => {
    const currentYear = new Date().getFullYear();
    const defaultMinYear = 1900;
    const defaultMaxYear = currentYear + 100; // Allow 100 years into the future by default

    const minYear = minDate ? parseDate(minDate).getFullYear() : defaultMinYear;
    const maxYear = maxDate ? parseDate(maxDate).getFullYear() : defaultMaxYear;

    return { minYear, maxYear };
  };
  const isSameDay = (d1, d2) => {
    if (!d1 || !d2) return false;
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  };

  const isToday = (date) => {
    if (!date) return false;

    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  // Format date for display in readable format (Feb 11, 2025)

  const formatDateReadable = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return "";

    if (showDropdown && isToday(date)) return "Today";

    try {
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const formatDateWithTime = (date, hrs, mins, per) => {
    if (!date) return "";
    const dateStr = formatDateReadable(date);
    return `${dateStr} ${hrs}:${mins} ${per}`;
  };

  // Format date for input (MM/DD/YYYY)
  const formatDate = (date) => {
    if (!date || !(date instanceof Date) || isNaN(date)) return "";
    try {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const formatDateRange = () => {
    if (fromDate && toDate) {
      return `${formatDateReadable(fromDate)} - ${formatDateReadable(toDate)}`;
    } else if (fromDate) {
      return `${formatDateReadable(fromDate)} - Select end date`;
    } else {
      return ""; // Use the provided placeholder instead of hardcoded text
    }
  };

  // Parse MM/DD/YYYY input
  const parseInputDate = (input) => {
    const cleaned = input.replace(/\D/g, ""); // Remove non-digits

    if (cleaned.length < 8) return null; // Need at least MMDDYYYY

    const month = parseInt(cleaned.substring(0, 2), 10);
    const day = parseInt(cleaned.substring(2, 4), 10);
    const year = parseInt(cleaned.substring(4, 8), 10);

    const { minYear, maxYear } = getYearLimits();

    if (
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31 ||
      year < minYear ||
      year > maxYear
    ) {
      return null;
    }

    const date = new Date(year, month - 1, day);
    if (date.getMonth() !== month - 1) return null; // Invalid date like Feb 30

    return date;
  };

  // Auto-format input as user types
  const formatInput = (value) => {
    const cleaned = value.replace(/\D/g, "");
    let formatted = "";

    if (cleaned.length >= 1) {
      formatted = cleaned.substring(0, 2);
    }
    if (cleaned.length >= 3) {
      formatted += "/" + cleaned.substring(2, 4);
    }
    if (cleaned.length >= 5) {
      formatted += "/" + cleaned.substring(4, 8);
    }

    return formatted;
  };

  // Auto-correct invalid dates with dynamic year limits
  const autoCorrectDate = (
    input,
    preserveTime = false,
    existingDate = null,
  ) => {
    const cleaned = input.replace(/\D/g, "");
    if (cleaned.length < 8) return null;

    let month = parseInt(cleaned.substring(0, 2), 10);
    let day = parseInt(cleaned.substring(2, 4), 10);
    let year = parseInt(cleaned.substring(4, 8), 10);

    const { minYear, maxYear } = getYearLimits();

    // Auto-correct month
    if (month > 12) month = 12;
    if (month < 1) month = 1;

    // Auto-correct year based on minDate and maxDate
    if (year < minYear) year = minYear;
    if (year > maxYear) year = maxYear;

    // Auto-correct day based on month and year
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day > daysInMonth) day = daysInMonth;
    if (day < 1) day = 1;

    let correctedDate;

    if (preserveTime && existingDate) {
      // Preserve time from existing date
      correctedDate = new Date(
        year,
        month - 1,
        day,
        existingDate.getHours(),
        existingDate.getMinutes(),
        existingDate.getSeconds(),
        existingDate.getMilliseconds(),
      );
    } else if (showTime) {
      // Use current time picker values
      let hrs = parseInt(hours, 10);
      if (period === "PM" && hrs !== 12) hrs += 12;
      if (period === "AM" && hrs === 12) hrs = 0;

      correctedDate = new Date(
        year,
        month - 1,
        day,
        hrs,
        parseInt(minutes, 10),
      );
    } else {
      correctedDate = new Date(year, month - 1, day);
    }

    // Validate against min/max dates
    if (minDate && correctedDate < minDate) {
      return minDate;
    }
    if (maxDate && correctedDate > maxDate) {
      return maxDate;
    }

    return correctedDate;
  };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;

    // If the input is being cleared, handle it properly
    if (value === "") {
      setInputValue("");
      setIsTyping(true);
      return;
    }

    setIsTyping(true);

    // Handle paste or direct input of invalid dates
    if (value.length >= 8 && value !== inputValue) {
      const correctedDate = autoCorrectDate(value);
      if (correctedDate) {
        const formattedDate = formatDate(correctedDate);
        setInputValue(formattedDate);

        if (!range) {
          setSelectedDate(correctedDate);
          onChange(correctedDate);
          setIsTyping(false);
        } else {
          if (selectionMode === "from") {
            setFromDate(correctedDate);
            setSelectionMode("to");
            onChange({ from: correctedDate, to: toDate });
          } else {
            setToDate(correctedDate);
            setSelectionMode("from");
            onChange({ from: fromDate, to: correctedDate });
            setIsTyping(false);
          }
        }
        return;
      }
    }

    // Format the input normally
    const formatted = formatInput(value);
    setInputValue(formatted);

    // Try to parse complete date
    const parsedDate = parseInputDate(formatted);
    if (parsedDate && formatted.length === 10) {
      if (!range) {
        setSelectedDate(parsedDate);
        onChange(parsedDate);
        setIsTyping(false);
      } else {
        if (selectionMode === "from") {
          setFromDate(parsedDate);
          setSelectionMode("to");
          onChange({ from: parsedDate, to: toDate });
        } else {
          setToDate(parsedDate);
          setSelectionMode("from");
          onChange({ from: fromDate, to: parsedDate });
          setIsTyping(false);
        }
      }
    }
  };

  // Handle backspace logic
  const handleKeyDown = (e) => {
    const input = e.target;
    const isTextSelected = input.selectionStart !== input.selectionEnd;
    const displayValue = getDisplayValue();

    if (e.key === "Backspace") {
      e.preventDefault();

      // If there's any selected date or if text is selected, clear everything
      if (
        isTextSelected ||
        (!range && selectedDate) ||
        (range && (fromDate || toDate))
      ) {
        // Clear the input
        setInputValue("");
        setIsTyping(true);

        // Clear dates based on range mode
        if (range) {
          if (toDate) {
            // Remove end date first
            setToDate(null);
            setSelectionMode("to");
            onChange({ from: fromDate, to: null });
          } else if (fromDate) {
            // Remove start date
            setFromDate(null);
            setSelectionMode("from");
            onChange({ from: null, to: null });
          }
        } else {
          // Single date mode - remove the date
          setSelectedDate(null);
          onChange(null);
        }
      } else if (isTyping && inputValue) {
        // If user is typing, allow normal backspace behavior for the input
        const newValue = inputValue.slice(0, -1);
        setInputValue(newValue);
      }
    } else if (e.key === "Delete") {
      // Handle Delete key same as Backspace for selected text or complete dates
      if (
        isTextSelected ||
        (!range && selectedDate) ||
        (range && (fromDate || toDate))
      ) {
        e.preventDefault();
        setInputValue("");
        setIsTyping(true);

        if (range) {
          if (toDate) {
            setToDate(null);
            setSelectionMode("to");
            onChange({ from: fromDate, to: null });
          } else if (fromDate) {
            setFromDate(null);
            setSelectionMode("from");
            onChange({ from: null, to: null });
          }
        } else {
          setSelectedDate(null);
          onChange(null);
        }
      }
    } else if (e.key === "Enter") {
      // Try to parse and set the date on Enter
      let parsedDate = parseInputDate(inputValue);

      // If invalid, try auto-correction
      if (!parsedDate && inputValue) {
        parsedDate = autoCorrectDate(inputValue);
        if (parsedDate) {
          const correctedFormat = formatDate(parsedDate);
          setInputValue(correctedFormat);
        }
      }

      if (parsedDate) {
        if (!range) {
          setSelectedDate(parsedDate);
          onChange(parsedDate);
        } else {
          if (selectionMode === "from") {
            setFromDate(parsedDate);
            setSelectionMode("to");
            onChange({ from: parsedDate, to: toDate });
          } else {
            setToDate(parsedDate);
            setSelectionMode("from");
            onChange({ from: fromDate, to: parsedDate });
          }
        }
        setIsTyping(false);
      }
      setIsOpen(false);
    }
  };

  // Handle input blur
  const handleInputBlur = () => {
    if (!inputValue) {
      setIsTyping(false);
      return;
    }

    let parsedDate = parseInputDate(inputValue);

    // If invalid, try auto-correction
    if (!parsedDate) {
      const existingDate = !range
        ? selectedDate
        : selectionMode === "from"
          ? fromDate
          : toDate;
      parsedDate = autoCorrectDate(inputValue, showTime, existingDate);
      if (parsedDate) {
        const correctedFormat = formatDate(parsedDate);
        setInputValue(correctedFormat);
      }
    } else if (showTime) {
      // Apply current time to parsed date
      let hrs = parseInt(hours, 10);
      if (period === "PM" && hrs !== 12) hrs += 12;
      if (period === "AM" && hrs === 12) hrs = 0;

      parsedDate = new Date(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate(),
        hrs,
        parseInt(minutes, 10),
      );
    }

    if (parsedDate) {
      if (!range) {
        setSelectedDate(parsedDate);
        onChange(parsedDate);
      } else {
        if (selectionMode === "from") {
          setFromDate(parsedDate);
          setSelectionMode("to");
          onChange({ from: parsedDate, to: toDate });
        } else {
          setToDate(parsedDate);
          setSelectionMode("from");
          onChange({ from: fromDate, to: parsedDate });
        }
      }
      setIsTyping(false);
    } else {
      // Invalid input that couldn't be corrected - revert to previous value
      setIsTyping(false);
      if (!range) {
        setInputValue(selectedDate ? formatDate(selectedDate) : "");
      } else {
        setInputValue("");
      }
    }
  };

  // Handle paste events
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = (e.clipboardData || window.clipboardData).getData(
      "text",
    );

    // Try to auto-correct pasted date
    const correctedDate = autoCorrectDate(pastedText);
    if (correctedDate) {
      const formattedDate = formatDate(correctedDate);
      setInputValue(formattedDate);
      setIsTyping(false);

      if (!range) {
        setSelectedDate(correctedDate);
        onChange(correctedDate);
      } else {
        if (selectionMode === "from") {
          setFromDate(correctedDate);
          setSelectionMode("to");
          onChange({ from: correctedDate, to: toDate });
        } else {
          setToDate(correctedDate);
          setSelectionMode("from");
          onChange({ from: fromDate, to: correctedDate });
        }
      }
    } else {
      // If can't auto-correct, just format what we can
      const formatted = formatInput(pastedText);
      setInputValue(formatted);
      setIsTyping(true);
    }
  };

  // Update input value when dates change externally
  useEffect(() => {
    if (!isTyping) {
      if (range) {
        setInputValue("");
      } else {
        setInputValue(selectedDate ? formatDate(selectedDate) : "");
      }
    }
  }, [selectedDate, fromDate, toDate, isTyping, range]);

  // Get display value for input
  //   const getDisplayValue = () => {
  //     // When user is actively typing, show the raw input
  //     if (isTyping) {
  //       return inputValue;
  //     }

  //     // When not typing, show formatted display values
  //     if (range) {
  //       return formatDateRange();
  //     } else {
  //       return showTime && selectedDate
  //         ? formatDateWithTime(selectedDate, hours, minutes, period)
  //         : selectedDate
  //         ? formatDateReadable(selectedDate)
  //         : "";
  //     }
  //   };
  const getDisplayValue = () => {
    if (isTyping) return inputValue;

    // Show preset label ONLY if not custom
    if (selectedPreset && selectedPreset.value !== 12) {
      return selectedPreset.label;
    }

    // For Date Range
    if (showDropdown && range && fromDate && toDate) {
      const matchedOption = optionsToShow?.find((opt) => {
        if (opt?.value === 12) return false;
        const result = getDateByOption(opt?.value);
        if (!result?.startDate || !result?.endDate) return false;
        return (
          isSameDay(fromDate, result?.startDate) &&
          isSameDay(toDate, result?.endDate)
        );
      });

      if (matchedOption) {
        setSelectedPreset(matchedOption);
        return matchedOption?.label;
      }
    }

    // For Single date
    if (showDropdown && !range && selectedDate) {
      const matchedOption = optionsToShow?.find((opt) => {
        if (opt?.value === 12) return false;
        const result = getDateByOption(opt?.value);
        if (!(result instanceof Date)) return false;
        return isSameDay(selectedDate, result);
      });

      if (matchedOption) {
        setSelectedPreset(matchedOption);
        return matchedOption?.label;
      }
    }

    if (range && fromDate && toDate) {
      // If both are today → show only "Today"
      if (showDropdown && isToday(fromDate) && isToday(toDate)) {
        return "Today";
      }

      // If same date (not today)
      // if (isSameDay(fromDate, toDate)) {
      //   return formatDateReadable(fromDate);
      // }

      return `${formatDateReadable(fromDate)} - ${formatDateReadable(toDate)}`;
    }

    if (range && fromDate) {
      return `${formatDateReadable(fromDate)} - Select end date`;
    }

    if (showTime && selectedDate) {
      return formatDateWithTime(selectedDate, hours, minutes, period);
    }

    if (selectedDate) {
      return formatDateReadable(selectedDate);
    }

    return "";
  };

  const daysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate();
  };

  const isDateValid = (date) => {
    if (!date) return false;
    if (minDate && date < minDate) return false;
    if (maxDate && date > maxDate) return false;
    if (range && selectionMode === "to" && fromDate && date < fromDate)
      return false;
    return true;
  };

  useEffect(() => {
    if (selected) {
      setFromDate(parseDate(range ? selected?.from || selected?.start : null));
      setToDate(parseDate(range ? selected?.to || selected?.end : null));
    }
  }, [selected]);

  useEffect(() => {
    if (!range) {
      const parsedDate = parseDate(selected);
      if (parsedDate && isDateValid(parsedDate)) {
        setSelectedDate(parsedDate);
        setCurrentDate(parsedDate);
      }
    } else {
      const parsedFromDate = parseDate(selected?.from || selected?.start);
      const parsedToDate = parseDate(selected?.to || selected?.end);

      if (parsedFromDate) {
        setFromDate(parsedFromDate);
        setSelectionMode(parsedToDate ? "from" : "to");
        if (!currentDate || selectionMode === "from") {
          setCurrentDate(new Date(parsedFromDate));
        }
      }

      if (parsedToDate) {
        setToDate(parsedToDate);
        if (selectionMode === "to") {
          setCurrentDate(new Date(parsedToDate));
        }
      }
    }
  }, [selected, minDate, maxDate, range]);

  const handleDayClick = (day) => {
    setSelectedPreset(null);
    try {
      let finalHours = 0;
      let finalMinutes = 0;

      if (showTime) {
        finalHours = parseInt(hours, 10);
        if (period === "PM" && finalHours !== 12) {
          finalHours += 12;
        }
        if (period === "AM" && finalHours === 12) {
          finalHours = 0;
        }
        finalMinutes = parseInt(minutes, 10);
      }

      const newSelectedDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day,
        finalHours,
        finalMinutes,
        0,
        0,
      );

      if (isDateValid(newSelectedDate) && !isNaN(newSelectedDate)) {
        if (!range) {
          setTempSelectedDate(newSelectedDate);
          setSelectedDate(newSelectedDate);
          onChange(formatDateToLocalISO(newSelectedDate)); // CHANGED: format before sending
          setIsOpen(false);
        } else {
          if (selectionMode === "from") {
            // if (toDate && newSelectedDate > toDate) {
            //   setToDate(null);
            //   setFromDate(newSelectedDate);
            //   setSelectionMode("to");
            //   onChange({ from: newSelectedDate, to: null });
            // } else {
            //   setFromDate(newSelectedDate);
            //   setSelectionMode("to");
            //   onChange({ from: newSelectedDate, to: toDate });
            // }
            setFromDate(newSelectedDate);
            setToDate(null);
            setSelectionMode("to");
            onChange({ from: formatDateToLocalISO(newSelectedDate), to: null }); // CHANGED
          } else {
            setToDate(newSelectedDate);
            setSelectionMode("from");
            onChange({
              from: formatDateToLocalISO(fromDate),
              to: formatDateToLocalISO(newSelectedDate),
            });
            setIsOpen(false);
          }
          setTempSelectedDate(newSelectedDate);
        }
      }
    } catch (error) {
      console.error("Error creating date:", error);
    }
  };

  const handlePrevMonth = () => {
    const prevMonth = new Date(
      currentDate.setMonth(currentDate.getMonth() - 1),
    );
    setCurrentDate(new Date(prevMonth));
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(
      currentDate.setMonth(currentDate.getMonth() + 1),
    );
    setCurrentDate(new Date(nextMonth));
  };

  const handleTodayClick = () => {
    const today = new Date();

    if (showTime) {
      let hrs = parseInt(hours, 10);
      if (period === "PM" && hrs !== 12) hrs += 12;
      if (period === "AM" && hrs === 12) hrs = 0;
      today.setHours(hrs, parseInt(minutes, 10), 0, 0);
    } else {
      today.setHours(0, 0, 0, 0);
    }

    setTempSelectedDate(today);
    setCurrentDate(today);

    if (!range) {
      setSelectedDate(today);
      onChange(formatDateToLocalISO(today));
    } else {
      if (selectionMode === "from") {
        setFromDate(today);
        setSelectionMode("to");
        onChange({
          from: formatDateToLocalISO(today),
          to: toDate ? formatDateToLocalISO(toDate) : null,
        });
      } else {
        setToDate(today);
        setSelectionMode("from");
        onChange({
          from: formatDateToLocalISO(fromDate),
          to: formatDateToLocalISO(today),
        });
      }
    }
    setIsOpen(false);
  };

  const handleDoneClick = () => {
    if (!range) {
      if (tempSelectedDate) {
        setSelectedDate(tempSelectedDate);
        try {
          if (typeof onChange === "function") {
            onChange(tempSelectedDate);
          }
        } catch (error) {
          console.error("Error in onChange handler:", error);
        }
      }
    } else {
      if (tempSelectedDate) {
        if (selectionMode === "from") {
          setFromDate(tempSelectedDate);
          setSelectionMode("to");
          onChange({ from: tempSelectedDate, to: toDate });
        } else {
          setToDate(tempSelectedDate);
          setSelectionMode("from");
          onChange({ from: fromDate, to: tempSelectedDate });
          setIsOpen(false);
        }
      }

      if (selectionMode === "to" && fromDate && !tempSelectedDate) {
        setIsOpen(false);
      }
    }

    setIsOpen(false);
    setShowMonthsList(false);
    setShowYearsList(false);
  };

  const handleClearClick = () => {
    if (!range) {
      setSelectedDate(null);
      onChange(null);
    } else {
      setFromDate(null);
      setToDate(null);
      setSelectionMode("from");
      onChange({ from: null, to: null });
    }
    setInputValue("");
    setIsTyping(false);
    setIsOpen(false);
  };

  const handleIconClick = (e) => {
    e.stopPropagation();
    if (range) {
      if (fromDate || toDate) {
        setFromDate(null);
        setToDate(null);
        setSelectionMode("from");
        onChange({ from: null, to: null });
        setInputValue("");
        setIsTyping(false);
      }
    } else {
      if (selectedDate) {
        setSelectedDate(null);
        onChange(null);
        setInputValue("");
        setIsTyping(false);
      }
    }
  };

  const handleTimeChange = (type, value) => {
    if (type === "hours") setHours(value);
    if (type === "minutes") setMinutes(value);
    if (type === "period") setPeriod(value);

    // Update the selected date with new time
    if (selectedDate && !range) {
      let hrs = type === "hours" ? parseInt(value, 10) : parseInt(hours, 10);
      const mins =
        type === "minutes" ? parseInt(value, 10) : parseInt(minutes, 10);
      const per = type === "period" ? value : period;

      if (per === "PM" && hrs !== 12) hrs += 12;
      if (per === "AM" && hrs === 12) hrs = 0;

      const updatedDate = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        hrs,
        mins,
        0,
        0,
      );

      setSelectedDate(updatedDate);
      onChange(formatDateToLocalISO(updatedDate));
    }
  };

  useEffect(() => {
    const handleKeyDownGlobal = (e) => {
      if (!isOpen && !showMonthsList && !showYearsList) return;

      switch (e.key) {
        case "Escape":
          setIsOpen(false);
          setShowMonthsList(false);
          setShowYearsList(false);
          break;
        case "ArrowLeft":
          if (!showMonthsList && !showYearsList) handlePrevMonth();
          break;
        case "ArrowRight":
          if (!showMonthsList && !showYearsList) handleNextMonth();
          break;
        case "Enter":
          if (showMonthsList) {
            setShowMonthsList(false);
            setIsOpen(true);
          } else if (showYearsList) {
            setShowYearsList(false);
            setIsOpen(true);
          }
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDownGlobal);
    return () => document.removeEventListener("keydown", handleKeyDownGlobal);
  }, [isOpen, showMonthsList, showYearsList]);

  const renderCalendar = () => {
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    ).getDay();
    const daysInCurrentMonth = daysInMonth(
      currentDate.getMonth() + 1,
      currentDate.getFullYear(),
    );
    const days = [];

    const prevMonthDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
    const prevMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      0,
    );
    const prevMonthDaysCount = prevMonth.getDate();

    for (
      let i = prevMonthDaysCount - prevMonthDays;
      i <= prevMonthDaysCount;
      i++
    ) {
      days.push({ day: i, isPrevMonth: true });
    }

    for (let i = 1; i <= daysInCurrentMonth; i++) {
      days.push({ day: i, isPrevMonth: false });
    }

    const totalDays = days.length;
    const missingDays = totalDays % 7;
    if (missingDays !== 0) {
      for (let i = 1; i <= 7 - missingDays; i++) {
        days.push({ day: i, isPrevMonth: false, isNextMonth: true });
      }
    }

    return days.map((item, index) => {
      const date = new Date(
        currentDate.getFullYear(),
        item.isPrevMonth
          ? currentDate.getMonth() - 1
          : item.isNextMonth
            ? currentDate.getMonth() + 1
            : currentDate.getMonth(),
        item.day,
      );

      const isCurrentDay = date.toDateString() === new Date().toDateString();
      const isBeforeMinDate = minDate && date < minDate;
      const isAfterMaxDate = maxDate && date > maxDate;
      const isBeforeFromDate =
        range && selectionMode === "to" && fromDate && date < fromDate;

      const isBlockedDate = normalizedBlockedDates.includes(
        date.toDateString(),
      );

      const isFromDate =
        range &&
        fromDate &&
        date.getDate() === fromDate.getDate() &&
        date.getMonth() === fromDate.getMonth() &&
        date.getFullYear() === fromDate.getFullYear() &&
        !item.isPrevMonth &&
        !item.isNextMonth;

      const isToDate =
        range &&
        toDate &&
        date.getDate() === toDate.getDate() &&
        date.getMonth() === toDate.getMonth() &&
        date.getFullYear() === toDate.getFullYear() &&
        !item.isPrevMonth &&
        !item.isNextMonth;

      const isInRange =
        range &&
        fromDate &&
        toDate &&
        date > fromDate &&
        date < toDate &&
        !item.isPrevMonth &&
        !item.isNextMonth;

      const isSelectedDay =
        !range &&
        tempSelectedDate instanceof Date &&
        !isNaN(tempSelectedDate) &&
        tempSelectedDate.getDate() === item.day &&
        tempSelectedDate.getMonth() === currentDate.getMonth() &&
        tempSelectedDate.getFullYear() === currentDate.getFullYear() &&
        !item.isPrevMonth &&
        !item.isNextMonth;

      const isPrevMonthDay = item.isPrevMonth;
      const isNextMonthDay = item.isNextMonth;

      return (
        <div
          key={index}
          className={`leading-none flex items-center justify-center rounded-full ${
            item.day ? "cursor-pointer" : "cursor-default"
          } p-2 w-7 h-7 text-center  ${
            isSelectedDay ? "bg-primary-600 text-white" : ""
          } ${isFromDate ? "bg-primary-600 text-white" : ""} ${
            isToDate ? "bg-primary-600 text-white" : ""
          } ${isInRange && !isBlockedDate ? "bg-primary-100" : ""} ${
            isCurrentDay ? "border-[1px] border-primary-600" : ""
          } ${
            isBlockedDate
              ? "text-gray-300 cursor-not-allowed hover:cursor-not-allowed hover:text-gray-300 line-through decoration-gray-400"
              : "hover:bg-primary-600 hover:text-white"
          }
          ${
            isBeforeMinDate || isAfterMaxDate || isBeforeFromDate
              ? "text-gray-300"
              : ""
          } ${fontSizeDatesClasses[size]} ${
            isPrevMonthDay || isNextMonthDay
              ? "text-gray-300 cursor-default hover:bg-transparent hover:text-gray-300"
              : ""
          }`}
          onClick={() =>
            item.day &&
            !isBeforeMinDate &&
            !isAfterMaxDate &&
            !isBeforeFromDate &&
            !isPrevMonthDay &&
            !isNextMonthDay &&
            !isBlockedDate &&
            handleDayClick(item.day)
          }
        >
          {item.day || ""}
        </div>
      );
    });
  };

  // useEffect(() => {
  //   function handleClickOutside(event) {
  //     // Check if click is inside the dropdownRef (button) or the dropdownContainerRef (portal dropdown)
  //     if (
  //       (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
  //       (dropdownContainerRef.current &&
  //         dropdownContainerRef.current.contains(event.target))
  //     ) {
  //       return;
  //     }

  //     setIsOpen(false);
  //     setShowMonthsList(false);
  //     setShowYearsList(false);
  //   }
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      //   if (
      //     (dropdownRef.current && dropdownRef.current.contains(event.target)) ||
      //     (dropdownContainerRef.current &&
      //       dropdownContainerRef.current.contains(event.target))
      //   ) {
      //     return;
      //   }
      if (
        dropdownRef.current?.contains(event.target) ||
        dropdownContainerRef.current?.contains(event.target) ||
        isOpen
      ) {
        return;
      }

      const selectRoot = document.querySelector(".select-root");
      if (selectRoot && selectRoot.contains(event.target)) {
        return;
      }

      setIsOpen(false);
      setIsDropdownOpen(false);
      setShowMonthsList(false);
      setShowYearsList(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (!range) {
        setTempSelectedDate(selectedDate);
      } else {
        setTempSelectedDate(selectionMode === "from" ? fromDate : toDate);
      }
    }
  }, [isOpen, selectedDate, selectionMode, fromDate, toDate, range]);

  // Position dropdown using portal
  // useLayoutEffect(() => {
  //   if (
  //     (isOpen || showMonthsList || showYearsList) &&
  //     buttonRef.current &&
  //     dropdownContainerRef.current
  //   ) {
  //     const buttonRect = buttonRef.current.getBoundingClientRect();
  //     const dropdownContainer = dropdownContainerRef.current;

  //     dropdownContainer.style.top = `${buttonRect.bottom + window.scrollY}px`;
  //     dropdownContainer.style.left = `${buttonRect.left + window.scrollX}px`;
  //   }
  // }, [isOpen, showMonthsList, showYearsList]);

  // Replace the existing useLayoutEffect in CustomDatePicker (around lines 775-784) with this:

  useLayoutEffect(() => {
    if (
      (isOpen || showMonthsList || showYearsList || isDropdownOpen) &&
      buttonRef.current &&
      dropdownContainerRef.current
    ) {
      const updatePosition = () => {
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const dropdownRect =
          dropdownContainerRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        // Calculate available space
        const spaceBelow = viewportHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;

        // Determine if dropdown should be below or above button
        const showBelow =
          spaceBelow >= Math.min(320, dropdownRect.height) ||
          spaceBelow >= spaceAbove;

        // Calculate left position
        let left = buttonRect.left + window.scrollX;
        // Adjust if dropdown would overflow right edge
        if (left + dropdownRect.width > viewportWidth) {
          left = Math.max(0, viewportWidth - dropdownRect.width);
        }

        // Calculate top position
        let top;
        if (showBelow) {
          top = buttonRect.bottom + window.scrollY + 8; // Add 8px gap
          // Check if dropdown extends beyond bottom of viewport
          if (top + dropdownRect.height > viewportHeight + window.scrollY) {
            top = viewportHeight + window.scrollY - dropdownRect.height - 8;
          }
        } else {
          top = buttonRect.top + window.scrollY - dropdownRect.height - 8; // Add 8px gap above
          // Check if dropdown extends beyond top of viewport
          if (top < window.scrollY) {
            top = window.scrollY + 8;
          }
        }

        // Apply the calculated position
        dropdownContainerRef.current.style.left = `${left}px`;
        dropdownContainerRef.current.style.top = `${top}px`;
      };

      // Initial position update
      updatePosition();

      // Update position on scroll and resize
      const handleScroll = () => {
        requestAnimationFrame(updatePosition);
      };

      // Add scroll event listeners
      window.addEventListener("scroll", handleScroll, true);
      window.addEventListener("resize", handleScroll);

      // Cleanup
      return () => {
        window.removeEventListener("scroll", handleScroll, true);
        window.removeEventListener("resize", handleScroll);
      };
    }
  }, [isOpen, showMonthsList, showYearsList, isDropdownOpen]);
  // const getDateRangeByOption = (value) => {
  //   const now = new Date();
  //   let startDate = null;
  //   let endDate = new Date(now);

  //   // Normalize end date to now
  //   endDate.setHours(23, 59, 59, 999);

  //   switch (value) {
  //     // Today
  //     case 1: {
  //       startDate = new Date(now);
  //       startDate.setHours(0, 0, 0, 0);

  //       break;
  //     }

  //     // Yesterday
  //     case 2: {
  //       startDate = new Date(now);
  //       startDate.setDate(startDate.getDate() - 1);
  //       startDate.setHours(0, 0, 0, 0);

  //       endDate = new Date(startDate);
  //       endDate.setHours(23, 59, 59, 999);
  //       break;
  //     }

  //     // This Week (Monday → today)
  //     case 3: {
  //       const day = now.getDay(); // 0 = Sunday
  //       const diff = day === 0 ? 6 : day - 1; // make Monday first day

  //       startDate = new Date(now);
  //       startDate.setDate(now.getDate() - diff);
  //       startDate.setHours(0, 0, 0, 0);
  //       break;
  //     }

  //     // Last Week (Monday → Sunday)
  //     case 4: {
  //       const day = now.getDay();
  //       const diff = day === 0 ? 6 : day - 1;

  //       startDate = new Date(now);
  //       startDate.setDate(now.getDate() - diff - 7);
  //       startDate.setHours(0, 0, 0, 0);

  //       endDate = new Date(startDate);
  //       endDate.setDate(startDate.getDate() + 6);
  //       endDate.setHours(23, 59, 59, 999);
  //       break;
  //     }

  //     // Fortnight (Last 15 days including today)
  //     case 5: {
  //       startDate = new Date(now);
  //       startDate.setDate(now.getDate() - 14);
  //       startDate.setHours(0, 0, 0, 0);
  //       break;
  //     }

  //     // This Month
  //     case 6: {
  //       startDate = new Date(now.getFullYear(), now.getMonth(), 1);
  //       startDate.setHours(0, 0, 0, 0);
  //       break;
  //     }

  //     // Last Month
  //     case 7: {
  //       startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  //       startDate.setHours(0, 0, 0, 0);

  //       endDate = new Date(now.getFullYear(), now.getMonth(), 0);
  //       endDate.setHours(23, 59, 59, 999);
  //       break;
  //     }

  //     // Last 3 Months (rolling)
  //     case 8: {
  //       startDate = new Date(now);
  //       startDate.setMonth(now.getMonth() - 3);
  //       startDate.setHours(0, 0, 0, 0);
  //       break;
  //     }

  //     // Last 6 Months (rolling)
  //     case 9: {
  //       startDate = new Date(now);
  //       startDate.setMonth(now.getMonth() - 6);
  //       startDate.setHours(0, 0, 0, 0);
  //       break;
  //     }

  //     // This Year
  //     case 10: {
  //       startDate = new Date(now.getFullYear(), 0, 1);
  //       startDate.setHours(0, 0, 0, 0);
  //       break;
  //     }

  //     // Last Year
  //     case 11: {
  //       startDate = new Date(now.getFullYear() - 1, 0, 1);
  //       startDate.setHours(0, 0, 0, 0);

  //       endDate = new Date(now.getFullYear() - 1, 11, 31);
  //       endDate.setHours(23, 59, 59, 999);
  //       break;
  //     }

  //     // Custom Range
  //     case 12: {
  //       setIsOpen(true);
  //       return null;
  //     }
  //     /// Single Date (Today)
  //     case 13: {
  //       const today = new Date();
  //       today.setHours(0, 0, 0, 0);
  //       return today;
  //     }
  //     /// Single Date (Yesterday)
  //     case 14: {
  //       const now = new Date();
  //       const yesterday = new Date(
  //         now.getFullYear(),
  //         now.getMonth(),
  //         now.getDate() - 1
  //       );
  //       return yesterday;
  //     }

  //     default:
  //       return null;
  //   }

  //   return { startDate, endDate };
  // };

  const handleOptionSelect = (option) => {
    // Check if option is disabled
    if (
      option.value !== 12 &&
      isOptionDisabled(option.value, minDate, normalizedBlockedDates)
    ) {
      return;
    }

    setIsDropdownOpen(false);
    setShowMonthsList(false);
    setShowYearsList(false);

    // Custom range
    if (option.value === 12) {
      setSelectedPreset(null);
      setSelectionMode("from");
      setTimeout(() => setIsOpen(true), 0);
      return;
    }

    const result = getDateByOption(option.value);
    // SINGLE DATE MODE
    if (!range && result instanceof Date) {
      console.log("result", result);
      setSelectedDate(result);
      setCurrentDate(result);
      setSelectedPreset(option);

      onChange(formatDateToLocalISO(result));
      setIsOpen(false);
      return;
    }

    //  RANGE MODE
    if (range && result?.startDate) {
      setFromDate(result.startDate);
      setToDate(result.endDate);
      setSelectionMode("from");
      setSelectedPreset(option);

      onChange({
        from: formatDateToLocalISO(result.startDate),
        to: formatDateToLocalISO(result.endDate),
      });

      setIsOpen(false);
    }
  };
  const isOptionDisabled = (optionValue, minDate, normalizedBlockedDates) => {
    const result = getDateByOption(optionValue);
    // For single date options (Today, Yesterday)
    if (result instanceof Date) {
      const resultDateStr = result.toDateString();

      // Check if date is before minDate
      if (minDate) {
        const minDateNormalized = new Date(minDate);
        minDateNormalized.setHours(0, 0, 0, 0);
        const resultNormalized = new Date(result);
        resultNormalized.setHours(0, 0, 0, 0);

        if (resultNormalized < minDateNormalized) {
          return true;
        }
      }

      // Check if date is in blocked dates
      if (normalizedBlockedDates.includes(resultDateStr)) {
        return true;
      }
    }

    // For range options (This Week, Last Week, etc.)
    if (result?.startDate && result?.endDate) {
      const start = new Date(result.startDate);
      const end = new Date(result.endDate);

      // Check if entire range is blocked
      let allBlocked = true;
      let current = new Date(start);

      while (current <= end) {
        const currentDateStr = current.toDateString();
        if (!normalizedBlockedDates.includes(currentDateStr)) {
          allBlocked = false;
          break;
        }
        current.setDate(current.getDate() + 1);
      }

      if (allBlocked) {
        return true;
      }
    }

    return false;
  };
  return (
    <div className="relative w-full min-w-32" ref={dropdownRef}>
      <div
        ref={buttonRef}
        className={`w-full border flex justify-between items-center ${
          fontSizeClasses[size]
        } ${rounded} 
        ${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}
        ${
          disabled
            ? "border-neutrals-200 cursor-not-allowed bg-neutrals-200 text-black"
            : "bg-white hover:border-primary-600 focus-within:border-primary-600 focus-within:outline-none"
        }`}
      >
        <input
          ref={inputRef}
          className={`w-full bg- border-0 text-black focus:outline-none cursor-pointer ${rounded} ${
            sizeClasses[size]
          } ${fontSizeClasses[size]} ${
            disabled ? "bg-neutrals-200 cursor-not-allowed" : " bg-white"
          }`}
          onClick={() => {
            if (showMonthsList || showYearsList) {
              setShowMonthsList(false);
              setShowYearsList(false);
            }
            if (range && showDropdown) {
              // if (!isDropdownOpen) {
              setIsOpen(false);
              setIsDropdownOpen(true);
              // }
            } else if (!range && showDropdown) {
              // if (!isDropdownOpen) {
              setIsOpen(false);
              setIsDropdownOpen(true);
              // }
            } else {
              setIsOpen(!isOpen);
            }
          }}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          onBlur={handleInputBlur}
          onPaste={handlePaste}
          disabled={disabled}
          placeholder={placeholder}
          value={getDisplayValue()}
          maxLength={range ? 100 : 10} // Allow longer input for ranges
        />
        {isDropdownOpen &&
          createPortal(
            <div
              ref={dropdownContainerRef}
              style={{
                position: "fixed",
                width: buttonRef.current?.offsetWidth,
              }}
              className="z-[55] max-h-60 overflow-y-auto bg-white border border-gray-200 rounded-md shadow-lg"
              onMouseDown={(e) => e.stopPropagation()}
            >
              {optionsToShow?.map((option) => {
                const isDisabled =
                  option.value !== 12 &&
                  isOptionDisabled(
                    option.value,
                    minDate,
                    normalizedBlockedDates,
                  );

                return (
                  <div
                    key={option.value}
                    className={`px-3 py-2 text-sm ${
                      isDisabled
                        ? "cursor-not-allowed bg-gray-100 text-gray-400"
                        : "cursor-pointer hover:bg-gray-100"
                    }`}
                    onMouseDown={(e) => {
                      if (isDisabled) {
                        e.preventDefault();
                        e.stopPropagation();
                        return;
                      }
                      e.stopPropagation();
                      handleOptionSelect(option);
                    }}
                  >
                    {option.label}
                  </div>
                );
              })}
            </div>,
            document.querySelector(".select-root"),
          )}

        <span
          className={`mx-2 material-icons transition-transform ${
            iconSizeClasses[size]
          } ${
            disabled
              ? "cursor-not-allowed bg-neutrals-200 text-black"
              : "cursor-pointer"
          }`}
          onClick={(e) => {
            if (disabled) return;

            if (range ? fromDate || toDate : selectedDate) {
              handleIconClick(e);
              setSelectedPreset(null);
            } else {
              e.stopPropagation();
              if (showMonthsList || showYearsList) {
                setShowMonthsList(false);
                setShowYearsList(false);
              }
              // setIsOpen(!isOpen);
              if (range && showDropdown) {
                // if (!isDropdownOpen) {
                setIsDropdownOpen(true);
                // }
              } else if (!range && showDropdown) {
                // if (!isDropdownOpen) {
                setIsDropdownOpen(true);
                // }
              } else {
                setIsOpen(!isOpen);
              }
            }
          }}
        >
          {(range ? fromDate || toDate : selectedDate)
            ? "close"
            : "calendar_month"}
        </span>
      </div>

      {isOpen &&
        createPortal(
          <div
            ref={dropdownContainerRef}
            style={{
              position: "fixed",
              width: buttonRef.current?.offsetWidth,
            }}
            className="z-[55] bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-80"
          >
            <div className="px-4 pt-3 flex justify-between items-center">
              <div className="flex items-center gap-1 border-[1px] border-gray-100 p-1 px-1">
                <Button
                  type="icon"
                  color="black"
                  variant="text"
                  size="sm"
                  icon={"west"}
                  onClick={handlePrevMonth}
                />

                <div>
                  <Button
                    variant="text"
                    size="sm"
                    color="black"
                    title={fullMonths[currentDate.getMonth()]}
                    onClick={() => {
                      if (showMonthsList) {
                        setShowMonthsList(false);
                        setIsOpen(true);
                      } else {
                        setShowMonthsList(true);
                        setShowYearsList(false);
                        setIsOpen(false);
                      }
                    }}
                  />
                </div>

                <Button
                  type="icon"
                  variant="text"
                  size="sm"
                  color="black"
                  icon={"east"}
                  onClick={handleNextMonth}
                />
              </div>
              <div className="border-[1px] border-gray-100 p-1 px-3">
                <Button
                  variant="text"
                  size="sm"
                  color="black"
                  title={currentDate.getFullYear()}
                  onClick={() => {
                    if (showYearsList) {
                      setShowYearsList(false);
                      setIsOpen(true);
                    } else {
                      setShowYearsList(true);
                      setShowMonthsList(false);
                      setIsOpen(false);
                    }
                  }}
                />
              </div>
            </div>

            {range && (
              <div className="px-4 pt-2">
                <div className="text-sm font-medium text-primary-600">
                  {selectionMode === "from"
                    ? "Select start date"
                    : "Select end date"}
                </div>
              </div>
            )}

            <div className="grid grid-cols-7 place-items-center gap-1 px-2 py-4">
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                <div
                  key={day}
                  className={`flex justify-center items-center w-7 h-7 ${fontSizeDatesClasses[size]}`}
                >
                  {day[0]}
                </div>
              ))}
              {renderCalendar()}
            </div>

            {showTime && (
              <div
                className="border-t border-gray-200 px-2"
                onClick={(e) => e.stopPropagation()}
              >
                <h3 className="text-sm font-semibold">Select Time</h3>

                <div className="grid grid-cols-3 gap-3 mb-3">
                  <div>
                    <FormFieldSet
                      type="select"
                      noTitle={false}
                      title="Hours"
                      placeholder="HH"
                      size="sm"
                      options={hoursArray}
                      value={hours}
                      onChange={(value) => handleTimeChange("hours", value)}
                    />
                  </div>

                  <div>
                    <FormFieldSet
                      type="select"
                      noTitle={false}
                      title="Minutes"
                      placeholder="MM"
                      size="sm"
                      options={minutesArray}
                      value={minutes}
                      onChange={(value) => handleTimeChange("minutes", value)}
                    />
                  </div>

                  <div>
                    <FormFieldSet
                      type="select"
                      noTitle={false}
                      title="Period"
                      placeholder="AM/PM"
                      size="sm"
                      options={periodArray}
                      value={period}
                      onChange={(value) => handleTimeChange("period", value)}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* <hr />
            <div className="flex items-center justify-between px-4 py-4">
              <Button
                variant="text"
                color="black"
                title="Clear"
                onClick={handleClearClick}
              />
              <div className="flex items-center gap-2">
                <Button
                  variant="text"
                  color="black"
                  title="Today"
                  onClick={handleTodayClick}
                />
                <Button title="Done" size="md" onClick={handleDoneClick} />
              </div>
            </div> */}
          </div>,
          document.querySelector(".select-root"),
        )}

      {showMonthsList &&
        createPortal(
          <div
            ref={dropdownContainerRef}
            style={{
              position: "fixed",
              width: buttonRef.current?.offsetWidth,
            }}
            className="z-[55] p-4 bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-80"
          >
            <div className="grid grid-cols-3 gap-4">
              {fullMonths.map((month, index) => (
                <Button
                  key={index}
                  variant={
                    month === fullMonths[currentDate.getMonth()]
                      ? "outlined"
                      : "text"
                  }
                  color={
                    month === fullMonths[currentDate.getMonth()]
                      ? "primary"
                      : "black"
                  }
                  title={month.slice(0, 3)}
                  onClick={() => {
                    setCurrentDate(new Date(currentDate.setMonth(index)));
                    setShowMonthsList(false);
                    setIsOpen(true);
                  }}
                />
              ))}
            </div>
          </div>,
          document.querySelector(".select-root"),
        )}

      {showYearsList &&
        createPortal(
          <div
            ref={dropdownContainerRef}
            style={{
              position: "fixed",
              width: buttonRef.current?.offsetWidth,
            }}
            className="z-[55] p-4 bg-white border border-gray-200 rounded-lg shadow-lg select-none min-w-64 max-w-80"
          >
            <div className="flex justify-between gap-1 items-center mb-4">
              <Button
                type="icon"
                size="xs-sm"
                icon={"west"}
                onClick={() => {
                  const { minYear } = getYearLimits();
                  const newYear = Math.max(
                    currentDate.getFullYear() - 9,
                    minYear,
                  );
                  setCurrentDate(new Date(currentDate.setFullYear(newYear)));
                }}
              />
              <span className="text-sm font-medium">
                {currentDate.getFullYear()}
              </span>
              <Button
                type="icon"
                size="xs-sm"
                icon={"east"}
                onClick={() => {
                  const { maxYear } = getYearLimits();
                  const newYear = Math.min(
                    currentDate.getFullYear() + 9,
                    maxYear,
                  );
                  setCurrentDate(new Date(currentDate.setFullYear(newYear)));
                }}
              />
            </div>
            <div className="grid grid-cols-3 gap-4">
              {(() => {
                const { minYear, maxYear } = getYearLimits();
                const currentYear = currentDate.getFullYear();
                const startYear = Math.max(currentYear - 4, minYear);
                const endYear = Math.min(startYear + 8, maxYear);
                const years = [];

                for (let year = startYear; year <= endYear; year++) {
                  years.push(year);
                }

                return years.map((year) => (
                  <Button
                    key={year}
                    title={year.toString()}
                    variant={currentYear === year ? "outlined" : "text"}
                    color={currentYear === year ? "primary" : "default"}
                    onClick={() => {
                      setCurrentDate(new Date(currentDate.setFullYear(year)));
                      setShowYearsList(false);
                      setIsOpen(true);
                      setShowMonthsList(false);
                    }}
                  />
                ));
              })()}
            </div>
          </div>,
          document.querySelector(".select-root"),
        )}
    </div>
  );
};

export default CustomDatePicker;
